<template>
  <div>
    <div class="card card-custom gutter-b" style="box-shadow: none">
      <div class="card-header card-header-tabs-line">
        <ul
          class="nav nav-dark nav-bold nav-tabs nav-tabs-line"
          role="tablist"
          ref="builder-tab"
        >
          <li class="nav-item">
            <a
              class="nav-link active"
              v-on:click="setActiveTab"
              data-tab="0"
              data-toggle="tab"
              href="#"
              role="tab"
            >
              Cadastro
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="1"
              data-toggle="tab1"
              href="#"
              role="tab1"
            >
              Dados Fiscais
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="2"
              data-toggle="tab3"
              href="#"
              role="tab1"
            >
              Dados GLP
            </a>
          </li>
          <li class="nav-item" v-if="isComposto">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="3"
              data-toggle="tab4"
              href="#"
              role="tab1"
            >
              Composição
            </a>
          </li>
          <li class="nav-item" v-if="isVariavel">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="4"
              data-toggle="tab5"
              href="#"
              role="tab1"
            >
              Variação
            </a>
          </li>
          <li class="nav-item" v-if="isPerca">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="5"
              data-toggle="tab6"
              href="#"
              role="tab1"
            >
              Decompor
            </a>
          </li>
          <li class="nav-item" v-if="isLote">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="6"
              data-toggle="tab7"
              href="#"
              role="tab1"
            >
              Lote
            </a>
          </li>
          <li class="nav-item" v-if="isRestaurante">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="7"
              data-toggle="tab8"
              href="#"
              role="tab1"
            >
              Restaurante
            </a>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              v-on:click="setActiveTab"
              data-tab="8"
              data-toggle="tab9"
              href="#"
              role="tab1"
            >
              Reforma Tributária
            </a>
          </li>
        </ul>
        <div class="produto-image-container">
          <div
            :class="{ 'produto-image-picker-empty': !urlProdutoImage }"
            :style="{
              width: '120px',
              height: '120px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '1rem',
              fontSize: '0.8rem',
            }"
            @click="selectFiles"
          >
            <b-card-img
              v-if="urlProdutoImage"
              :src="urlProdutoImage"
              class="rounded-0"
              style="
                object-fit: cover;
                width: 120px;
                height: 120px;
                object-position: center;
              "
            />
            <p v-else class="mb-0">Insira uma foto</p>
          </div>
          <b-button
            v-if="urlProdutoImage"
            variant="link"
            size="sm"
            class="produto-image-delete"
            @click.stop="removeProdutoImage"
          >
            Excluir foto
          </b-button>
        </div>
      </div>

      <div class="card-body">
        <b-tabs class="hide-tabs" v-model="tabIndex">
          <b-tab active>
            <b-row>
              <b-col md="2">
                <b-form-group id="codigo" label-for="codigo" label="Código">
                  <b-form-input v-model="form.codigo" disabled> </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group
                  :class="{ 'required-field': !form.descricao }"
                  id="descricao"
                  label-for="descricao"
                  label="Descrição"
                >
                  <b-form-input
                    maxlength="100"
                    v-model="$v.form.descricao.$model"
                    :state="validateState('descricao')"
                    autofocus
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group id="marca" label-for="marca" label="Marca">
                  <b-form-input maxlength="100" v-model="form.marca" autofocus>
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group id="custo" label-for="custo" label="Custo">
                  <money
                    class="form-control"
                    v-model="form.custo"
                    v-bind="priceOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="markup" label-for="markup" label="Markup %">
                  <money
                    class="form-control"
                    v-model="form.markup"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="quantidade"
                  label-for="quantidade"
                  label="Quantidade"
                >
                  <money
                    class="form-control"
                    v-model="form.quantidade"
                    v-bind="quantityOptions"
                    :disabled="isVariavel || isLote"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="preco" label-for="preco" label="Valor">
                  <money
                    class="form-control"
                    v-model="form.preco"
                    v-bind="priceOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="preco_atacado"
                  label-for="preco_atacado"
                  label="Valor Atacado"
                >
                  <money
                    class="form-control"
                    v-model="form.preco_atacado"
                    v-bind="priceOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="quantidade_atacado"
                  label-for="quantidade_atacado"
                  label="Quantidade Atacado"
                >
                  <money
                    class="form-control"
                    v-model="form.quantidade_atacado"
                    v-bind="quantityOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group
                  id="referencia"
                  label-for="referencia"
                  label="Referência"
                >
                  <b-form-input v-model="form.referencia" maxlength="50">
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  :class="{
                    'required-field':
                      form.id_medida == null || form.id_medida === '',
                  }"
                  label="Unidade de Medida"
                  label-for="unidade_medida"
                >
                  <select
                    name="unidade_medida"
                    id="unidade_medida"
                    v-model="form.id_medida"
                    class="form-control"
                  >
                    <option
                      v-for="(u, index) in unidadeMedida"
                      :value="u.id"
                      :key="'unidade_medida' + index"
                    >
                      {{ u.nome }}
                    </option>
                  </select>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group id="grupo" label="Grupo" label-for="grupo">
                  <VueSelect
                    placeholder="Digite o nome para pesquisar"
                    label="grupo"
                    :filterable="false"
                    @input="setGrupo"
                    :options="grupos"
                    @search="onSearchGrupo"
                    v-model="grupo"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o nome para buscar
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.nome }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="cod_barras"
                  label-for="cod_barras"
                  label="Código de Barras"
                >
                  <b-form-input v-model="form.cod_barras"> </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="cod_barras"
                  label-for="cod_barras"
                  style="margin-top: 25px"
                >
                  <button
                    @click="searchCodigoBarra(form.cod_barras)"
                    class="btn btn-md btn-primary btn-hover-primary btn-icon mr-2"
                    v-b-tooltip.hover.bottom="'Consultar via código de barras'"
                  >
                    <SearchWeb :size="20" />
                  </button>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="data_ultima_venda"
                  label-for="data_ultima_venda"
                  label="Data Últ. Venda"
                >
                  <b-form-input
                    :disabled="!form.id_produto"
                    v-model="form.data_ultima_venda"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="data_ultima_compra"
                  label-for="data_ultima_compra"
                  label="Data Últ. Compra"
                >
                  <b-form-input
                    :disabled="!form.id_produto"
                    v-model="form.data_ultima_compra"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="numero_ultima_compra"
                  label-for="numero_ultima_compra"
                  label="Número Últ. Compra"
                >
                  <b-form-input
                    v-model="form.numero_ultima_compra"
                    maxlength="20"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group
                  id="fornecedor"
                  label="Fornecedor Preferencial"
                  label-for="fornecedor"
                >
                  <VueSelect
                    placeholder="Digite o nome para pesquisar"
                    label="fornecedor"
                    :filterable="false"
                    @input="setFornecedor"
                    :options="fornecedores"
                    @search="onSearchFornecedor"
                    v-model="fornecedor"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o nome para buscar
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.nome }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo + " - " + option.nome }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="peso" label-for="peso" label="Peso">
                  <money
                    class="form-control"
                    v-model="form.peso"
                    v-bind="quantityOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="estoque_minimo"
                  label-for="estoque_minimo"
                  label="Estoque Mínimo"
                >
                  <money
                    class="form-control"
                    v-model="form.estoque_minimo"
                    v-bind="quantityOptions"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group id="tipo" label="Tipo" label-for="tipo">
                  <b-form-select v-model="form.id_tipo" placeholder="">
                    <b-form-select-option
                      v-for="tipo in tipos"
                      :key="tipo.id + 'plano_contas'"
                      :value="tipo.id"
                    >
                      {{ tipo.descricao }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group id="origem" label="Origem" label-for="origem">
                  <b-form-select v-model="form.id_origem" placeholder="">
                    <b-form-select-option
                      v-for="origem in origens"
                      :key="origem.id + 'origem'"
                      :value="origem.id"
                    >
                      {{ origem.descricao }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group
                  id="descricao"
                  label-for="desc_complementar"
                  label="Descrição Complementar"
                >
                  <b-form-input
                    v-model="form.desc_complementar"
                    maxlength="250"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <input
                  id="fileUpload"
                  ref="fileUpload"
                  type="file"
                  hidden
                  accept=".jpg, .png"
                  @change="setProdutoImage"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group id="obs" label="Observação" label-for="obs">
                  <b-form-textarea
                    id="obs"
                    name="obs"
                    v-model="form.obs"
                    placeholder=""
                  >
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="1"
                ><br />
                <b-form-group id="ativo" label-for="ativo" label="Ativo">
                  <span class="switch switch-icon">
                    <label>
                      <input
                        type="checkbox"
                        :value="true"
                        @change="setAtivo"
                        :checked="form.ativo == true"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group
                  id="composto"
                  label-for="composto"
                  label="Composto"
                >
                  <span class="switch switch-icon">
                    <label>
                      <input
                        type="checkbox"
                        @change="setComposto"
                        :checked="isComposto"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group
                  id="variacao"
                  label-for="variacao"
                  label="Variação"
                >
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" v-model="isVariavel" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group id="perca" label-for="perca" label="Decompor">
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" v-model="isPerca" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group id="pesado" label-for="pesado" label="Pesado">
                  <span class="switch switch-icon">
                    <label>
                      <input
                        type="checkbox"
                        @change="setPesado"
                        :checked="form.pesado == true"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group id="lote" label-for="lote" label="Lote">
                  <span class="switch switch-icon">
                    <label>
                      <input type="checkbox" v-model="isLote" />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
              <b-col md="1"
                ><br />
                <b-form-group
                  id="restaurante"
                  label-for="restaurante"
                  label="Restaurante"
                >
                  <span class="switch switch-icon">
                    <label>
                      <input
                        type="checkbox"
                        v-model="isRestaurante"
                        @change="setRestaurante"
                      />
                      <span></span>
                    </label>
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <button
              v-b-modal.modal-assistant
              class="btn btn-primary font-weight-bold"
            >
              Assistente para cálculo do preço de venda
            </button>
          </b-tab>

          <b-tab>
            <b-row>
              <b-col md="4">
                <b-form-group label-for="perfil_tributario">
                  <template #label>
                    Perfil Tributário
                    <span
                      v-b-tooltip.hover.right="
                        'Conjunto de configurações fiscais (CST, CFOP, NCM, alíquotas, etc.) que será aplicado automaticamente ao produto na emissão de documentos fiscais.'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o nome para pesquisar"
                    label="descricao"
                    :filterable="false"
                    @input="setPerfilTributario"
                    :options="perfisTributarios"
                    @search="onSearchPerfilTributario"
                    v-model="perfilTributario"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o nome para buscar
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group
                  label="CST/CSOSN não contribuinte"
                  label-for="form.id_cst_csosn"
                >
                  <template #label>
                    CST/CSOSN não contribuinte
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cst_csosn')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setCSTCSOSN"
                    v-model="cstcsosn"
                    :options="cstcsosns"
                    :disabled="isPerfilTributarioFieldLocked('id_cst_csosn')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código para buscar
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  label="CST/CSOSN contribuinte"
                  label-for="form.id_cst_csosn_contribuinte"
                >
                  <template #label>
                    CST/CSOSN contribuinte
                    <span
                      v-if="
                        isPerfilTributarioFieldLocked(
                          'id_cst_csosn_contribuinte'
                        )
                      "
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setCSTCSOSNContribuinte"
                    v-model="cstcsosnContribuinte"
                    :options="cstcsosns"
                    :disabled="
                      isPerfilTributarioFieldLocked('id_cst_csosn_contribuinte')
                    "
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código para buscar
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="CFOP NFe" label-for="form.id_cfop">
                  <template #label>
                    CFOP NFe
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cfop')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    ref="buscarCliente"
                    :filterable="false"
                    v-model="cfop"
                    @input="setCFOP"
                    :options="cfops"
                    @search="onSearchCFOP"
                    :disabled="isPerfilTributarioFieldLocked('id_cfop')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CFOP
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="CFOP NFce" label-for="form.id_cfop_nfce">
                  <template #label>
                    CFOP NFce
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cfop_nfce')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    ref="buscarCliente"
                    :filterable="false"
                    v-model="cfop_nfce"
                    @input="setCFOPNFce"
                    :options="cfops_nfce"
                    @search="onSearchCFOPNfce"
                    :disabled="isPerfilTributarioFieldLocked('id_cfop_nfce')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CFOP
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <b-form-group label="CEST" label-for="form.id_cest">
                  <template #label>
                    CEST
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cest')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setCEST"
                    v-model="cest"
                    :options="cests"
                    @search="onSearchCEST"
                    :disabled="isPerfilTributarioFieldLocked('id_cest')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CEST
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{
                          option.codigo + " - " + option.descricao
                            ? option.codigo +
                              " - " +
                              option.descricao.substring(0, 55) +
                              "..."
                            : ""
                        }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="NCM" label-for="form.id_ncm">
                  <template #label>
                    NCM
                    <button
                      v-if="hasPerfilTributarioNcmConflict()"
                      type="button"
                      class="perfil-tributario-ncm-action ml-1"
                      v-b-tooltip.hover.right="getPerfilTributarioNcmTooltip()"
                      @click.prevent="confirmApplyPerfilTributarioNCM"
                    >
                      !
                    </button>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setNCM"
                    v-model="ncm"
                    :options="ncms"
                    @search="onSearchNCM"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do NCM
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="excecaoFiscal" label-for="excecaoFiscal">
                  <template #label>
                    Exceção Fiscal
                    <span
                      v-if="isPerfilTributarioFieldLocked('excecaoFiscal')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <b-form-input
                    v-model="form.excecaoFiscal"
                    :disabled="isPerfilTributarioFieldLocked('excecaoFiscal')"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="CENQ" label-for="form.id_cenq">
                  <template #label>
                    CENQ
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cenq')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setCENQ"
                    v-model="cenq"
                    :options="cenqs"
                    :disabled="isPerfilTributarioFieldLocked('id_cenq')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CENQ
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="CST IPI" label-for="form.id_cstipi">
                  <template #label>
                    CST IPI
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cstipi')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    placeholder="Digite o código para pesquisar"
                    label="codigo"
                    @input="setCSTIPI"
                    v-model="cstipi"
                    :options="cstipis"
                    @search="onSearchCSTIPI"
                    :disabled="isPerfilTributarioFieldLocked('id_cstipi')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CST IPI
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="CST PIS" label-for="form.id_cstpis">
                  <template #label>
                    CST PIS
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cstpis')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    label="codigo"
                    @input="setCSTPIS"
                    v-model="cstpis"
                    :options="cstspis"
                    placeholder="Digite o código para pesquisar"
                    :disabled="isPerfilTributarioFieldLocked('id_cstpis')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CST PIS
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="3">
                <b-form-group label="CST COFINS" label-for="form.id_cstcofins">
                  <template #label>
                    CST COFINS
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_cstcofins')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    label="codigo"
                    v-model="cstcofins"
                    @input="setCSTCofins"
                    :options="cstscofins"
                    placeholder="Digite o código para pesquisar"
                    :disabled="isPerfilTributarioFieldLocked('id_cstcofins')"
                    :clearable="true"
                  >
                    <template slot="no-options">
                      Informe o código do CST Cofins
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo + " - " + option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="tributacoes.length > 0">
                <b-form-group label="Tributação" label-for="form.id_tributacao">
                  <template #label>
                    Tributação
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_tributacao')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    label="descricao"
                    @input="setTributacao"
                    v-model="tributacao"
                    :options="tributacoes"
                    :disabled="isPerfilTributarioFieldLocked('id_tributacao')"
                    :clearable="true"
                  >
                    <template slot="no-options"> Informe a descricao </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{
                          option.descricao
                            ? option.descricao.substring(0, 20)
                            : ""
                        }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="tributacoes.length > 0">
                <b-form-group
                  label="Tributação ST"
                  label-for="form.id_tributacao_st"
                >
                  <template #label>
                    Tributação ST
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_tributacao_st')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    label="descricao"
                    @input="setTributacaoST"
                    v-model="tributacaoST"
                    :options="tributacoes"
                    :disabled="
                      isPerfilTributarioFieldLocked('id_tributacao_st')
                    "
                    :clearable="true"
                  >
                    <template slot="no-options"> Informe a descricao </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{
                          option.descricao
                            ? option.descricao.substring(0, 20)
                            : ""
                        }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3" v-if="tributacoes.length > 0">
                <b-form-group label="FCP" label-for="form.id_fcp">
                  <template #label>
                    FCP
                    <span
                      v-if="isPerfilTributarioFieldLocked('id_fcp')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <VueSelect
                    label="fcp"
                    @input="setFCP"
                    v-model="fcp"
                    :options="tributacoes"
                    :disabled="isPerfilTributarioFieldLocked('id_fcp')"
                    :clearable="true"
                  >
                    <template slot="no-options"> Informe a descricao </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.descricao }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{
                          option.descricao
                            ? option.descricao.substring(0, 20)
                            : ""
                        }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <b-form-group id="ipi" label-for="ipi">
                  <template #label>
                    % IPI
                    <span
                      v-if="isPerfilTributarioFieldLocked('ipi')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <money
                    class="form-control"
                    v-model="form.ipi"
                    :disabled="isPerfilTributarioFieldLocked('ipi')"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="pist" label-for="pis">
                  <template #label>
                    % PIS
                    <span
                      v-if="isPerfilTributarioFieldLocked('pis')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <money
                    class="form-control"
                    v-model="form.pis"
                    :disabled="isPerfilTributarioFieldLocked('pis')"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="cofins" label-for="cofins">
                  <template #label>
                    % COFINS
                    <span
                      v-if="isPerfilTributarioFieldLocked('cofins')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <money
                    class="form-control"
                    v-model="form.cofins"
                    :disabled="isPerfilTributarioFieldLocked('cofins')"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group id="mva" label-for="mva">
                  <template #label>
                    % MVA
                    <span
                      v-if="isPerfilTributarioFieldLocked('mva')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <money
                    class="form-control"
                    v-model="form.mva"
                    :disabled="isPerfilTributarioFieldLocked('mva')"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="codigo_beneficio"
                  label-for="codigo_beneficio"
                >
                  <template #label>
                    Código Benefício
                    <span
                      v-if="isPerfilTributarioFieldLocked('codigo_beneficio')"
                      v-b-tooltip.hover.right="
                        'Preenchido automaticamente pelo Perfil Tributário selecionado'
                      "
                      class="ml-1 text-muted"
                      style="cursor: pointer"
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </template>
                  <b-form-input
                    v-model="form.codigo_beneficio"
                    :disabled="
                      isPerfilTributarioFieldLocked('codigo_beneficio')
                    "
                    maxlength="20"
                  >
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row>
              <b-col md="3">
                <b-form-group label="ANP" label-for="form.id_anp">
                  <VueSelect
                    label="id_anp"
                    @input="setANP"
                    v-model="anp"
                    :options="anps"
                    placeholder="Digite o código para pesquisar"
                    @search="onSearchANP"
                    :filterable="false"
                  >
                    <template slot="no-options"> Informe a descricao </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="percentual_glp"
                  label-for="percentual_glp"
                  label="% de GLP Derivado do Petróleo"
                >
                  <money
                    class="form-control"
                    v-model="form.percentual_glp"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="percentual_gnn"
                  label-for="percentual_gnn"
                  label="% de Gás Natural Nacional"
                >
                  <money
                    class="form-control"
                    v-model="form.percentual_gnn"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="percentual_gni"
                  label-for="percentual_gni"
                  label="% de Gás Natural Importado"
                >
                  <money
                    class="form-control"
                    v-model="form.percentual_gni"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="valor_parti"
                  label-for="valor_parti"
                  label="Valor da partilha"
                >
                  <money
                    class="form-control"
                    v-model="form.valor_parti"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group
                  id="glp_qtd_tributavel"
                  label-for="glp_qtd_tributavel"
                  label="Quantidade Tributável"
                >
                  <money
                    class="form-control"
                    v-model="form.glp_qtd_tributavel"
                    v-bind="quantityOptions"
                  >
                  </money>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row align-v="center">
              <b-col md="6">
                <b-form-group label="Produto" label-for="name">
                  <VueSelect
                    ref="buscarProduto"
                    :filterable="false"
                    @input="setProduto"
                    :options="produtosFetched"
                    @search="onSearchProduto"
                    v-model="produtoSelected"
                  >
                    <template slot="no-options">
                      Informe o produto pelo nome
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex justify-content-between">
                        <div>{{ option.codigo }} - {{ option.descricao }}</div>
                        <span class="text-muted"
                          >QTD: {{ option.quantidade }}</span
                        >
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col :cols="windowWidth > 768 ? 0 : 6">
                <b-form-group label="Quantidade" label-for="quantidade">
                  <money
                    class="form-control"
                    ref="quantidade"
                    id="quantidade"
                    name="quantidade"
                    v-model="quantidade"
                    v-bind="quantityOptions"
                    v-on:keyup.native.enter="handleEnter('preco')"
                  />
                </b-form-group>
              </b-col>
              <b-col :cols="windowWidth > 768 ? 0 : 6">
                <b-form-group label="Custo unitário" label-for="preco">
                  <money
                    class="form-control"
                    ref="preco"
                    id="preco"
                    name="preco"
                    v-model="preco"
                    v-bind="priceOptions"
                    v-on:keyup.native.enter="addProduto(produtoSelected)"
                  />
                </b-form-group>
              </b-col>
              <b-col :cols="windowWidth > 768 ? 0 : 6">
                <b-form-group label="Total R$" label-for="total">
                  <money
                    disabled
                    class="form-control"
                    id="total"
                    name="total"
                    v-model="total"
                    v-bind="priceOptions"
                  />
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label-for="add">
                  <button @click="addProduto(produtoSelected)">
                    <Plus
                      class="btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
                      v-if="windowWidth > 768"
                    />
                    <button
                      v-else
                      class="btn btn-info btn-hover-dark font-weight-bolder font-size-lg ml-2"
                    >
                      Adicionar produto
                    </button>
                  </button>
                </b-form-group>
              </b-col>
            </b-row>

            <TableApp
              item="produto"
              subTitulo=""
              :data="produtos"
              :fields="fields"
              classFilterColumn="nome"
              ref="nome"
              :key="keyToRender"
            >
              <template slot="customRow" scope="props">
                <span
                  slot="item"
                  class="pl-0 pt-8"
                  v-if="props.field == 'item'"
                >
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{ props.rowData.originalIndex + 1 }} /
                      {{ props.rowData.product.codigo }}
                    </div>
                  </div>
                </span>
                <span
                  slot="nome"
                  class="pl-0 pt-8"
                  v-if="props.field == 'descricao'"
                >
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{ props.rowData.product.descricao }}
                      <span
                        v-b-tooltip.hover.right="
                          'Item atendeu a regra de preço de atacado'
                        "
                        v-if="props.rowData.product.tipo_atacado"
                      >
                        <InformationOutline :size="14" />
                      </span>
                    </div>
                  </div>
                </span>
                <span
                  slot="quantidade"
                  class="pl-0 pt-8"
                  v-if="props.field == 'quantidade'"
                >
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{
                        numberToReal(
                          props.rowData.product.quantidade,
                          "quantidade"
                        )
                      }}
                    </div>
                  </div>
                </span>
                <span
                  slot="preco"
                  class="pl-0 pt-8"
                  v-if="props.field == 'preco'"
                >
                  <div class="d-flex align-items-center">
                    <div class="font-weight-bold text-muted">
                      {{ numberToReal(props.rowData.product.custo, "preco") }}
                    </div>
                  </div>
                </span>

                <span
                  slot="total"
                  v-if="props.field == 'total'"
                  class="text-dark-75 font-weight-bolder d-block font-size-lg"
                >
                  R$
                  {{
                    numberToReal(
                      props.rowData.product.quantidade *
                        props.rowData.product.custo,
                      "preco"
                    )
                  }}
                </span>
                <span slot="actions" v-if="props.field == 'actions'">
                  <div class="row-actions" style="text-align: right !important">
                    <span
                      style="
                        overflow: visible;
                        position: relative;
                        width: 130px;
                      "
                    >
                      <div class="action-buttons">
                        <button
                          @click="
                            openModalProduto(
                              props.rowData,
                              props.rowData.originalIndex
                            )
                          "
                          class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                        >
                          <Pencil :size="16" title="Editar" />
                        </button>
                        <button
                          @click="handleDeleteProduto(props.rowData)"
                          class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                        >
                          <TrashCanIcon :size="16" />
                        </button>
                      </div>
                    </span>
                  </div>
                </span>
              </template>
            </TableApp>
            <b-row v-if="produtos.length > 0">
              <b-col></b-col>
              <b-col></b-col>
              <b-col
                ><span class="text-primary font-weight-bolder"
                  >Total Itens:</span
                >
                {{ numberToReal(totalItensComposicao, "quantidade") }}</b-col
              >
              <b-col
                ><span class="text-primary font-weight-bolder">Total R$:</span
                >{{
                  numberToReal(
                    produtos.reduce(
                      (acc, produto) => acc + produto.totalPrice,
                      0
                    ),
                    "preco"
                  )
                }}</b-col
              >
            </b-row>
          </b-tab>

          <b-tab>
            <b-row>
              <b-col>
                <!-- Variação 1 -->
                <b-row>
                  <b-col md="6">
                    <b-form-group label="Variação 1" label-for="name">
                      <VueSelect
                        ref="buscarVariacao"
                        :filterable="false"
                        :options="variacoesFetched1"
                        v-model="variacaoSelected1"
                        @search="
                          (search, loading) =>
                            onSearchVariacao(search, loading, 1)
                        "
                      >
                        <template slot="no-options">
                          Informe a variação pelo nome
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-flex justify-content-between">
                            <div>
                              {{ option.nome }}
                            </div>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.nome }}
                          </div>
                        </template>
                      </VueSelect>
                    </b-form-group>

                    <b-form-group
                      id="variaveis"
                      label-for="variaveis"
                      label="Variáveis"
                      v-if="!!variacaoSelected1"
                    >
                      <span class="text-muted">
                        {{
                          variacaoSelected1.variaveis
                            .map((el) => el.nome)
                            .join(", ")
                        }}
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Variação 2 -->
                <b-row class="border-top pt-4">
                  <b-col md="6">
                    <b-form-group label="Variação 2" label-for="name">
                      <VueSelect
                        ref="buscarVariacao"
                        :filterable="false"
                        :options="variacoesFetched2"
                        v-model="variacaoSelected2"
                        @search="
                          (search, loading) =>
                            onSearchVariacao(search, loading, 2)
                        "
                      >
                        <template slot="no-options">
                          Informe a variação pelo nome
                        </template>
                        <template slot="option" slot-scope="option">
                          <div class="d-flex justify-content-between">
                            <div>
                              {{ option.nome }}
                            </div>
                          </div>
                        </template>
                        <template slot="selected-option" slot-scope="option">
                          <div class="selected d-center">
                            {{ option.nome }}
                          </div>
                        </template>
                      </VueSelect>
                    </b-form-group>

                    <b-form-group
                      id="variaveis"
                      label-for="variaveis"
                      label="Variáveis"
                      v-if="!!variacaoSelected2"
                    >
                      <span class="text-muted">
                        {{
                          variacaoSelected2.variaveis
                            .map((el) => el.nome)
                            .join(", ")
                        }}
                      </span>
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Botão Mesclar/Confirmar -->
                <b-row>
                  <button
                    ref="mesclar_button"
                    @click="mesclarVariacoes"
                    class="btn btn-secondary border border-primary font-weight-bold"
                  >
                    {{
                      variacaoSelected2 && variacaoSelected1
                        ? "Mesclar"
                        : "Confirmar"
                    }}
                  </button>
                </b-row>
              </b-col>

              <!-- LISTA DE COMBINAÇÕES / ESTOQUE -->
              <b-col v-if="combinacao.length > 0">
                <div
                  class="d-flex justify-content-between align-items-center mb-3"
                >
                  <h4 class="mb-0">Estoque</h4>

                  <!-- Controles de seleção / remoção -->
                  <div class="d-flex align-items-center" style="gap: 15px">
                    <b-form-checkbox
                      v-model="selectAllCombinacoes"
                      @change="toggleSelectAllCombinacoes"
                    >
                      Selecionar todos
                    </b-form-checkbox>

                    <button
                      class="btn btn-sm btn-danger font-weight-bold"
                      :disabled="selectedCombinacoes.length === 0"
                      @click="removerCombinacoesSelecionadas"
                    >
                      Remover selecionados
                    </button>
                  </div>
                </div>

                <div style="max-height: 600px; overflow-y: scroll">
                  <b-row
                    v-for="(item, index) in combinacao"
                    :key="'combinacao-' + index"
                    class="d-flex align-items-center p-2"
                    :style="{
                      backgroundColor:
                        index % 2 !== 0 ? '#F0f0f0' : 'transparent',
                    }"
                  >
                    <!-- Checkbox para selecionar a combinação -->
                    <b-col md="1" class="d-flex justify-content-center">
                      <b-form-checkbox
                        v-model="selectedCombinacoes"
                        :value="item"
                      />
                    </b-col>

                    <!-- Dados da combinação -->
                    <b-col
                      v-for="(value, key) in item"
                      :key="'item-' + index + '-' + key"
                      :v-if="key !== 'quantidade'"
                    >
                      <template
                        v-if="typeof value === 'object' && value !== null"
                      >
                        <p class="mb-1">
                          <strong>{{ key }}</strong
                          >: {{ value.nome }}
                        </p>
                      </template>
                      <template v-else>
                        <p class="mb-1">
                          <strong>{{ key }}</strong
                          >: {{ value }}
                        </p>
                      </template>
                    </b-col>

                    <!-- Quantidade -->
                    <b-col md="2">
                      <b-form-group
                        id="quantidade_variacao"
                        label-for="quantidade_variacao"
                        label="Quantidade"
                      >
                        <money
                          class="form-control"
                          v-model="combinacao[index].quantidade"
                          v-bind="quantityOptions"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row align-v="center">
              <b-col md="6">
                <b-form-group
                  label="Produto que vai receber a quantidade da compra"
                  label-for="name"
                >
                  <VueSelect
                    ref="buscarProduto"
                    :filterable="false"
                    @input="setProdutoPerca"
                    :options="produtosFetched"
                    @search="onSearchProduto"
                    v-model="produtoSelectedPerca"
                  >
                    <template slot="no-options">
                      Informe o produto pelo nome
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex justify-content-between">
                        <div>{{ option.codigo }} - {{ option.descricao }}</div>
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                      <div class="selected d-center">
                        {{ option.codigo }} - {{ option.descricao }}
                      </div>
                    </template>
                  </VueSelect>
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group
                  id="perca_percentual"
                  label-for="perca_percentual"
                  label="Perca %"
                >
                  <money
                    class="form-control"
                    v-model="form.perca_percentual"
                    v-bind="configMoney"
                  >
                  </money>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row align-v="center">
              <b-col md="12">
                <b-card>
                  <h5>Gerenciamento de Lotes</h5>
                  <b-form-group class="d-flex align-items-center">
                    <!-- Ícone com Tooltip -->
                    <b-icon
                      icon="info-circle-fill"
                      id="tooltip-info"
                      variant="primary"
                      class="mr-2"
                    ></b-icon>
                    <b-tooltip target="tooltip-info" placement="top">
                      Quando ativado, o Nuts escolherá automaticamente o lote
                      mais antigo disponível (FIFO).
                    </b-tooltip>

                    <b-form-checkbox v-model="form.baixa_automatica_lote">
                      Baixa Automática do Lote
                    </b-form-checkbox>
                  </b-form-group>
                  <b-form @submit.prevent="adicionarLote">
                    <b-row>
                      <b-col md="3">
                        <b-form-group
                          :class="{ 'required-field': !novoLote.numero_lote }"
                          label="Número do Lote"
                        >
                          <b-form-input
                            v-model="novoLote.numero_lote"
                            required
                            maxLength="20"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          :class="{
                            'required-field': !novoLote.data_fabricacao,
                          }"
                          label="Data de Fabricação"
                        >
                          <b-form-input
                            type="date"
                            v-model="novoLote.data_fabricacao"
                            required
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col md="3">
                        <b-form-group
                          :class="{ 'required-field': !novoLote.data_validade }"
                          label="Data de Validade"
                        >
                          <b-form-input
                            type="date"
                            v-model="novoLote.data_validade"
                            required
                          ></b-form-input>
                        </b-form-group>
                      </b-col>

                      <b-col md="2">
                        <b-form-group label="Quantidade">
                          <money
                            class="form-control"
                            v-model="novoLote.quantidade"
                            v-bind="quantityOptions"
                          >
                          </money>
                        </b-form-group>
                      </b-col>

                      <b-col md="1" class="d-flex align-items-center">
                        <b-button type="submit" variant="primary"
                          >Adicionar</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-form>

                  <hr />

                  <b-table
                    striped
                    hover
                    bordered
                    :items="lotes"
                    :fields="campos"
                  >
                    <template #cell(data_fabricacao)="row">
                      {{ formatDate(row.item.data_fabricacao) }}
                    </template>

                    <template #cell(data_validade)="row">
                      {{ formatDate(row.item.data_validade) }}
                    </template>

                    <template #cell(quantidade)="row">
                      {{ numberToReal(row.item.quantidade, "quantidade") }}
                    </template>

                    <template #cell(acoes)="row">
                      <b-button
                        variant="danger"
                        @click="confirmarRemocao(row.index, row.item)"
                        ><TrashCanIcon :size="16"
                      /></b-button>
                    </template>
                  </b-table>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row>
              <b-col md="12">
                <b-card class="mb-3">
                  <h5 class="mb-4">Restaurante</h5>
                  <p class="text-muted font-weight-bold mb-4">
                    Defina para onde este produto deve ir quando for enviado
                    para produção.
                  </p>
                  <b-row>
                    <b-col md="3">
                      <b-form-checkbox
                        v-model="restauranteDestinos"
                        :disabled="restauranteSemPreparo"
                        value="cozinha"
                        switch
                      >
                        Cozinha
                      </b-form-checkbox>
                    </b-col>
                    <b-col md="3">
                      <b-form-checkbox
                        v-model="restauranteDestinos"
                        :disabled="restauranteSemPreparo"
                        value="bar"
                        switch
                      >
                        Bar
                      </b-form-checkbox>
                    </b-col>
                    <b-col md="3">
                      <b-form-checkbox
                        v-model="restauranteSemPreparo"
                        switch
                        @change="setRestauranteSemPreparo"
                      >
                        Sem preparo
                      </b-form-checkbox>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-tab>

          <b-tab>
            <b-row>
              <b-card class="mb-3">
                <!-- Aviso -->
                <div class="mb-3">
                  <div class="font-weight-bold">Atenção!</div>
                  <small class="text-muted">
                    Estamos acompanhando de perto as mudanças da Reforma
                    Tributária e para deixar essa transição mais simples e
                    transparente pra você, incluímos abaixo alguns campos que
                    simulam a nova tributação (IBS/CBS/IS). Esses dados são
                    orientativos e podem mudar conforme novas definições legais
                    forem publicadas.
                  </small>
                </div>

                <!-- Linha 1 -->
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Class. trib. IBS/CBS.">
                      <b-form-select
                        v-model="form.class_trib_ibs_cbs"
                        :options="optionsClassTribIbsCbsFiltered"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="CST IBS/CBS">
                      <b-form-select
                        v-model="form.cst_ibs_cbs"
                        :options="optionsCstIbsCbsArr"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Class. trib. regular">
                      <b-form-select
                        v-model="form.class_trib_regular"
                        :options="optionsClassTribRegularFiltered"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="CST regular">
                      <b-form-select
                        v-model="form.cst_regular"
                        :options="optionsCstRegular"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- Linha 2 -->
                <b-row>
                  <b-col md="3">
                    <b-form-group label="Cod. créd. Presumido">
                      <b-form-select
                        v-model="form.cod_cred_presumido"
                        :options="optionsCodCredPresumido"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3" class="d-flex align-items-end">
                    <b-form-group label="Ind. bem móvel usado" class="mb-0">
                      <b-form-checkbox
                        v-model="form.ind_bem_movel_usado"
                        switch
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- IBS -->
                <div class="mt-3 mb-2 text-muted font-weight-bold">
                  IBS - Imposto sobre Bens e Serviços
                </div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="% Redução base Mun.">
                      <money
                        class="form-control"
                        v-model="form.ibs_reducao_mun"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq efetiva Mun.">
                      <money
                        class="form-control"
                        v-model="form.ibs_aliquota_efetiva_mu"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Redução base UF">
                      <money
                        class="form-control"
                        v-model="form.ibs_reducao_uf"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq efetiva UF.">
                      <money
                        class="form-control"
                        v-model="form.ibs_aliquota_efetiva_uf"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Diferimento Mun.">
                      <money
                        class="form-control"
                        v-model="form.ibs_diferimento_mun"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Diferimento UF">
                      <money
                        class="form-control"
                        v-model="form.ibs_diferimento_uf"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- <b-col md="3">
                  <b-form-group label="% Aliq. créd. presumido">
                    <money class="form-control" v-model="form.ibs_aliq_cred_presumido" v-bind="configMoney" />
                  </b-form-group>
                </b-col> -->
                </b-row>

                <!-- CBS -->
                <div class="mt-2 mb-2 text-muted font-weight-bold">
                  CBS - Contribuição sobre Bens e Serviços
                </div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="% Diferimento">
                      <money
                        class="form-control"
                        v-model="form.cbs_diferimento"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Redução">
                      <money
                        class="form-control"
                        v-model="form.cbs_reducao"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Aliq. efetiva CBS">
                      <money
                        class="form-control"
                        v-model="form.cbs_aliq_cred_presumido"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>

                <!-- IS -->
                <div class="mt-2 mb-2 text-muted font-weight-bold">
                  IS - Imposto Seletivo
                </div>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="CST IS">
                      <b-form-select
                        :disabled="true"
                        v-model="form.cst_is"
                        :options="optionsCstIs"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="Class. trib. IS">
                      <b-form-select
                        :disabled="true"
                        v-model="form.class_trib_is"
                        :options="optionsClassTribIs"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Alíquota específica">
                      <money
                        class="form-control"
                        :disabled="true"
                        v-model="form.aliquota_especifica_is"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="3">
                    <b-form-group label="% Alíquota IS">
                      <money
                        class="form-control"
                        :disabled="true"
                        v-model="form.aliquota_is"
                        v-bind="configMoney"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-row>
          </b-tab>
        </b-tabs>
      </div>

      <b-modal
        id="modal-confirmar"
        ref="modalConfirmar"
        title="Confirmar Exclusão"
        hide-footer
      >
        <p>
          <strong>Número do Lote:</strong> {{ loteSelecionado.numero_lote }}
        </p>
        <p>
          <strong>Quantidade:</strong>
          {{ numberToReal(loteSelecionado.quantidade, "quantidade") }}
        </p>
        <p>Tem certeza que deseja remover este lote?</p>

        <b-row class="mt-3">
          <b-col>
            <b-button variant="secondary" @click="$refs.modalConfirmar.hide()"
              >Cancelar</b-button
            >
            <b-button variant="primary" @click="removerLoteConfirmado"
              >Confirmar</b-button
            >
          </b-col>
        </b-row>
      </b-modal>

      <ModalProduto
        :close="closeModalProduto"
        :changeProduto="saveEditProduto"
        :produto="produtoToEdit"
        :open="modalProdutoIsOpen"
        v-if="modalProdutoIsOpen"
      />

      <div class="card-footer">
        <div class="row">
          <div class="col-lg-12" style="text-align: center">
            <button
              type="submit"
              ref="submit_nova_recorrencia"
              @click="onSubmit"
              class="btn btn-primary font-weight-bold mr-2"
            >
              Salvar
            </button>
            <button
              v-if="produto.id || form.id"
              type="button"
              v-b-modal.modal-confirm-duplicar
              class="btn btn-light-primary font-weight-bold mr-2"
            >
              Duplicar
            </button>
            <router-link
              class="btn btn-clean font-weight-bold"
              :to="{
                name: 'produtosLista',
              }"
            >
              Cancelar
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-formula"
      title="Fórmula do preço de venda"
      size="md"
      centered
    >
      <label
        >Para calcular o preço de venda dos produtos o Assistente para cálculo
        do preço de venda utiliza a seguinte fórmula:</label
      >
      <b-row class="mt-10" align-h="center" align-v="center">
        <b-col md="4"> Preço de venda = </b-col>
        <b-col md="5">
          <b-row class="border-bottom border-dark mb-2" align-h="center">
            <span class="font-weight-bolder">Custo unitário</span>
          </b-row>
          <b-row align-h="center">
            (100 - (<span class="font-weight-bolder">Outros valores</span>)) /
            100
          </b-row>
        </b-col>
      </b-row>
      <template #modal-footer="{ ok }">
        <b-button size="sm" variant="primary" @click="ok()"> OK! </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-assistant"
      title="Assistente de valor de venda"
      size="md"
      centered
      @show="getAssistentePreco"
      @hidden="resetAssistentePreco"
    >
      <template #modal-header="{ close }">
        <h5>
          Assistente Preço de Venda
          <button
            class="btn btn-xs btn-primary btn-icon ml-2"
            v-b-tooltip="'Saiba mais sobre a formula aplicada'"
            v-b-modal.modal-formula
          >
            <Quest :size="16" />
          </button>
        </h5>

        <b-button size="sm" variant="outline-primary" @click="close()">
          X
        </b-button>
      </template>
      <div class="mx-auto">
        <b-row>
          <b-col md="6">
            <b-form-group id="custo" label-for="custo" label="Custo R$">
              <money
                class="form-control"
                v-model="form.custo"
                v-bind="priceOptions"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="icm-entrada"
              label-for="icm-entrada"
              label="% ICM de entrada (-)"
            >
              <money
                class="form-control"
                v-model="icmEntrada"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="icm-saida"
              label-for="icm-saida"
              label="% ICM de saída (+)"
            >
              <money
                class="form-control"
                v-model="icmSaida"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="custo-operacional"
              label-for="custo-operacional"
              label="% Custo operacional (+)"
            >
              <money
                class="form-control"
                v-model="custoOperacional"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="outros-impostos"
              label-for="outros-impostos"
              label="% Outros impostos (+)"
            >
              <money
                class="form-control"
                v-model="outrosImpostos"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group
              id="comissao"
              label-for="comissao"
              label="% Comissão (+)"
            >
              <money
                class="form-control"
                v-model="comissao"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="lucro" label-for="lucro" label="% Lucro (+)">
              <money
                class="form-control"
                v-model="lucro"
                v-bind="configMoney"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row align-h="end">
          <b-col md="8">
            <span class="font-size-lg font-weight-bolder mb-1"
              >Preço de venda sugerido:</span
            >
            <span class="text-primary font-size-h4">
              R$ {{ numberToReal(valorVendaCalculado, 2) }}</span
            >
          </b-col>
        </b-row>
      </div>
      <template #modal-footer="{ ok, cancel }">
        <b-button @click="cancel()"> Cancelar </b-button>
        <b-button
          variant="primary"
          @click="salvarValorVenda"
          ref="salvarValorVenda"
        >
          Aplicar
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="modal-confirm-duplicar"
      title="Deseja duplicar o produto?"
      centered
      size="sm"
      hide-footer
    >
      <p class="mb-0">
        Tem certeza que deseja duplicar o produto
        <strong>{{ form.descricao }}</strong> ?
      </p>
      <b-row class="mt-4">
        <b-col class="d-flex justify-content-end">
          <b-button
            variant="secondary"
            class="mr-2"
            @click="$bvModal.hide('modal-confirm-duplicar')"
          >
            Cancelar
          </b-button>
          <b-button
            variant="primary"
            ref="duplicar_produto"
            @click="duplicarProduto"
          >
            Confirmar
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import ProdutosData, { ProdutoDataRequired } from "./ProdutosData";
import { Money } from "v-money";
import {
  MONEY as settingMoney,
  priceOptions,
  quantityOptions,
} from "@/modules/Application";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import { mapGetters } from "vuex";
import Quest from "vue-material-design-icons/AccountQuestion.vue";
import { onboardStore } from "../../../onboardStore";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TableApp from "@/components/Table/Table3.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import SearchWeb from "vue-material-design-icons/Barcode.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import ModalProduto from "./ModalProduto.vue";

const camposNumericosProduto = [
  "custo",
  "markup",
  "quantidade",
  "preco",
  "preco_atacado",
  "quantidade_atacado",
  "peso",
  "estoque_minimo",
  "ipi",
  "pis",
  "cofins",
  "mva",
  "percentual_glp",
  "percentual_gnn",
  "percentual_gni",
  "valor_parti",
  "glp_qtd_tributavel",
  "perca_percentual",
  "ibs_reducao_mun",
  "ibs_aliquota_efetiva_mu",
  "ibs_reducao_uf",
  "ibs_aliquota_efetiva_uf",
  "ibs_diferimento_mun",
  "ibs_diferimento_uf",
  "ibs_aliq_cred_presumido",
  "cbs_diferimento",
  "cbs_reducao",
  "cbs_aliq_cred_presumido",
  "aliquota_especifica_is",
  "aliquota_is",
];

const optionsClassTribIbsCbs = [
  {
    value: "000001",
    text: "000001 - Situações tributadas integralmente pelo IBS e CBS.",
    cst: "000",
  },
  {
    value: "000002",
    text: "000002 - Exploração de via",
    cst: "000",
  },
  {
    value: "000003",
    text: "000003 - Regime automotivo - projetos incentivados (art. 311)",
    cst: "000",
  },
  {
    value: "000004",
    text: "000004 - Regime automotivo - projetos incentivados (art. 312)",
    cst: "000",
  },
  {
    value: "010001",
    text: "010001 - Operações do FGTS não realizadas pela Caixa Econômica Federal",
    cst: "010",
  },
  {
    value: "010002",
    text: "010002 - Operações do serviço financeiro",
    cst: "010",
  },
  {
    value: "011001",
    text: "011001 - Planos de assistência funerária.",
    cst: "011",
  },
  {
    value: "011002",
    text: "011002 - Planos de assistência à saúde",
    cst: "011",
  },
  {
    value: "011003",
    text: "011003 - Intermediação de planos de assistência à saúde",
    cst: "011",
  },
  {
    value: "011004",
    text: "011004 - Concursos e prognósticos",
    cst: "011",
  },
  {
    value: "011005",
    text: "011005 - Planos de assistência à saúde de animais domésticos",
    cst: "011",
  },
  {
    value: "200001",
    text: "200001 - Aquisições realizadas entre empresas autorizadas a operar em zonas de processamento de exportação",
    cst: "200",
  },
  {
    value: "200002",
    text: "200002 - Fornecimento ou importação para produtor rural não contribuinte ou TAC",
    cst: "200",
  },
  {
    value: "200003",
    text: "200003 - Vendas de produtos destinados à alimentação humana (Anexo I)",
    cst: "200",
  },
  {
    value: "200004",
    text: "200004 - Venda de dispositivos médicos (Anexo XII)",
    cst: "200",
  },
  {
    value: "200005",
    text: "200005 - Venda de dispositivos médicos adquiridos por órgãos da administração pública (Anexo IV)",
    cst: "200",
  },
  {
    value: "200006",
    text: "200006 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XII)",
    cst: "200",
  },
  {
    value: "200007",
    text: "200007 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo XIII)",
    cst: "200",
  },
  {
    value: "200008",
    text: "200008 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência adquiridos por órgãos da administração pública (Anexo V)",
    cst: "200",
  },
  {
    value: "200009",
    text: "200009 - Fornecimento de medicamentos (Anexo XIV)",
    cst: "200",
  },
  {
    value: "200010",
    text: "200010 - Fornecimento dos medicamentos registrados na Anvisa, adquiridos por órgãos da administração pública",
    cst: "200",
  },
  {
    value: "200011",
    text: "200011 - Fornecimento das composições para nutrição enteral e parenteral quando adquiridas por órgãos da administração pública (Anexo VI)",
    cst: "200",
  },
  {
    value: "200012",
    text: "200012 - Situação de emergência de saúde pública reconhecida pelo Poder público (Anexo XIV)",
    cst: "200",
  },
  {
    value: "200013",
    text: "200013 - Fornecimento de tampões higiênicos, absorventes higiênicos internos ou externos",
    cst: "200",
  },
  {
    value: "200014",
    text: "200014 - Fornecimento dos produtos hortícolas, frutas e ovos (Anexo XV)",
    cst: "200",
  },
  {
    value: "200015",
    text: "200015 - Venda de automóveis de passageiros de fabricação nacional adquiridos por motoristas profissionais ou pessoas com deficiência",
    cst: "200",
  },
  {
    value: "200016",
    text: "200016 - Prestação de serviços de pesquisa e desenvolvimento por Instituição Científica, Tecnológica e de Inovação (ICT)",
    cst: "200",
  },
  {
    value: "200017",
    text: "200017 - Operações relacionadas ao FGTS",
    cst: "200",
  },
  {
    value: "200018",
    text: "200018 - Operações de resseguro e retrocessão",
    cst: "200",
  },
  {
    value: "200019",
    text: "200019 - Importador dos serviços financeiros contribuinte",
    cst: "200",
  },
  {
    value: "200020",
    text: "200020 - Operação praticada por sociedades cooperativas optantes por regime específico do IBS e CBS",
    cst: "200",
  },
  {
    value: "200021",
    text: "200021 - Serviços de transporte público coletivo de passageiros ferroviário e hidroviário",
    cst: "200",
  },
  {
    value: "200022",
    text: "200022 - Operação originada fora da ZFM que destine bem material industrializado a contribuinte estabelecido na ZFM",
    cst: "200",
  },
  {
    value: "200023",
    text: "200023 - Operação realizada por indústria incentivada que destine bem material intermediário para outra indústria incentivada na ZFM",
    cst: "200",
  },
  {
    value: "200024",
    text: "200024 - Operação originada fora das Áreas de Livre Comércio destinadas a contribuinte estabelecido nas Áreas de Livre Comércio",
    cst: "200",
  },
  {
    value: "200025",
    text: "200025 - Fornecimento dos serviços de educação relacionados ao Programa Universidade para Todos (Prouni)",
    cst: "200",
  },
  {
    value: "200026",
    text: "200026 - Locação de imóveis localizados nas zonas reabilitadas",
    cst: "200",
  },
  {
    value: "200027",
    text: "200027 - Operações de locação, cessão onerosa e arrendamento de bens imóveis",
    cst: "200",
  },
  {
    value: "200028",
    text: "200028 - Fornecimento dos serviços de educação (Anexo II)",
    cst: "200",
  },
  {
    value: "200029",
    text: "200029 - Fornecimento dos serviços de saúde humana (Anexo III)",
    cst: "200",
  },
  {
    value: "200030",
    text: "200030 - Venda dos dispositivos médicos (Anexo IV)",
    cst: "200",
  },
  {
    value: "200031",
    text: "200031 - Fornecimento dos dispositivos de acessibilidade próprios para pessoas com deficiência (Anexo V)",
    cst: "200",
  },
  {
    value: "200032",
    text: "200032 - Fornecimento dos medicamentos registrados na Anvisa ou produzidos por farmácias de manipulação, ressalvados os medicamentos sujeitos à alíquota zero",
    cst: "200",
  },
  {
    value: "200033",
    text: "200033 - Fornecimento das composições para nutrição enteral e parenteral (Anexo VI)",
    cst: "200",
  },
  {
    value: "200034",
    text: "200034 - Fornecimento dos alimentos destinados ao consumo humano (Anexo VII)",
    cst: "200",
  },
  {
    value: "200035",
    text: "200035 - Fornecimento dos produtos de higiene pessoal e limpeza (Anexo VIII)",
    cst: "200",
  },
  {
    value: "200036",
    text: "200036 - Fornecimento de produtos agropecuários, aquícolas, pesqueiros, florestais e extrativistas vegetais in natura",
    cst: "200",
  },
  {
    value: "200037",
    text: "200037 - Fornecimento de serviços ambientais de conservação ou recuperação da vegetação nativa",
    cst: "200",
  },
  {
    value: "200038",
    text: "200038 - Fornecimento dos insumos agropecuários e aquícolas (Anexo IX)",
    cst: "200",
  },
  {
    value: "200039",
    text: "200039 - Fornecimento dos serviços e o licenciamento ou cessão dos direitos destinados às produções nacionais artísticas (Anexo X)",
    cst: "200",
  },
  {
    value: "200040",
    text: "200040 - Fornecimento de serviços de comunicação institucional à administração pública",
    cst: "200",
  },
  {
    value: "200041",
    text: "200041 - Fornecimento de serviço de educação desportiva (art. 141. I)",
    cst: "200",
  },
  {
    value: "200042",
    text: "200042 - Fornecimento de serviço de educação desportiva (art. 141. II)",
    cst: "200",
  },
  {
    value: "200043",
    text: "200043 - Fornecimento à administração pública dos serviços e dos bens relativos à soberania (Anexo XI)",
    cst: "200",
  },
  {
    value: "200044",
    text: "200044 - Operações e prestações de serviços de segurança da informação e segurança cibernética desenv por sociedade que tenha sócio brasileiro (Anexo XI)",
    cst: "200",
  },
  {
    value: "200045",
    text: "200045 - Operações relacionadas a projetos de reabilitação urbana de zonas históricas e de áreas críticas de recuperação e reconversão urbanística",
    cst: "200",
  },
  {
    value: "200046",
    text: "200046 - Operações com bens imóveis",
    cst: "200",
  },
  {
    value: "200047",
    text: "200047 - Bares e Restaurantes",
    cst: "200",
  },
  {
    value: "200048",
    text: "200048 - Hotelaria, Parques de Diversão e Parques Temáticos",
    cst: "200",
  },
  {
    value: "200049",
    text: "200049 - Transporte coletivo de passageiros rodoviário, ferroviário e hidroviário",
    cst: "200",
  },
  {
    value: "200050",
    text: "200050 - Serviços de transporte aéreo regional coletivo de passageiros ou de carga",
    cst: "200",
  },
  {
    value: "200051",
    text: "200051 - Agências de Turismo",
    cst: "200",
  },
  {
    value: "200052",
    text: "200052 - Prestação de serviços de profissões intelectuais",
    cst: "200",
  },
  {
    value: "220001",
    text: "220001 - Incorporação imobiliária submetida ao regime especial de tributação",
    cst: "220",
  },
  {
    value: "220002",
    text: "220002 - Incorporação imobiliária submetida ao regime especial de tributação",
    cst: "220",
  },
  {
    value: "220003",
    text: "220003 - Alienação de imóvel decorrente de parcelamento do solo",
    cst: "220",
  },
  {
    value: "221001",
    text: "221001 - Locação, cessão onerosa ou arrendamento de bem imóvel com alíquota sobre a receita bruta",
    cst: "221",
  },
  {
    value: "222001",
    text: "222001 - Transporte internacional de passageiros, caso os trechos de ida e volta sejam vendidos em conjunto",
    cst: "222",
  },
  {
    value: "400001",
    text: "400001 - Fornecimento de serviços de transporte público coletivo de passageiros rodoviário e metroviário",
    cst: "400",
  },
  {
    value: "410001",
    text: "410001 - Fornecimento de bonificações quando constem no documento fiscal e que não dependam de evento posterior",
    cst: "410",
  },
  {
    value: "410002",
    text: "410002 - Transferências entre estabelecimentos pertencentes ao mesmo contribuinte",
    cst: "410",
  },
  {
    value: "410003",
    text: "410003 - Doações sem contraprestação em benefício do doador",
    cst: "410",
  },
  {
    value: "410004",
    text: "410004 - Exportações de bens e serviços",
    cst: "410",
  },
  {
    value: "410005",
    text: "410005 - Fornecimentos realizados pela União, pelos Estados, pelo Distrito Federal e pelos Municípios",
    cst: "410",
  },
  {
    value: "410006",
    text: "410006 - Fornecimentos realizados por entidades religiosas e templos de qualquer culto",
    cst: "410",
  },
  {
    value: "410007",
    text: "410007 - Fornecimentos realizados por partidos políticos",
    cst: "410",
  },
  {
    value: "410008",
    text: "410008 - Fornecimentos de livros, jornais, periódicos e do papel destinado a sua impressão",
    cst: "410",
  },
  {
    value: "410009",
    text: "410009 - Fornecimentos de fonogramas e videofonogramas musicais produzidos no Brasil",
    cst: "410",
  },
  {
    value: "410010",
    text: "410010 - Fornecimentos de serviço de comunicação nas modalidades de radiodifusão sonora e de sons e imagens de recepção livre e gratuita",
    cst: "410",
  },
  {
    value: "410011",
    text: "410011 - Fornecimentos de ouro, quando definido em lei como ativo financeiro ou instrumento cambial",
    cst: "410",
  },
  {
    value: "410012",
    text: "410012 - Fornecimento de condomínio edilício não optante pelo regime regular",
    cst: "410",
  },
  {
    value: "410013",
    text: "410013 - Exportações de combustíveis",
    cst: "410",
  },
  {
    value: "410014",
    text: "410014 - Fornecimento de produtor rural não contribuinte",
    cst: "410",
  },
  {
    value: "410015",
    text: "410015 - Fornecimento por transportador autônomo não contribuinte",
    cst: "410",
  },
  {
    value: "410016",
    text: "410016 - Fornecimento ou aquisição de resíduos sólidos",
    cst: "410",
  },
  {
    value: "410017",
    text: "410017 - Aquisição de bem móvel com crédito presumido sob condição de revenda realizada",
    cst: "410",
  },
  {
    value: "410018",
    text: "410018 - Operações relacionadas aos fundos garantidores e executores de políticas públicas",
    cst: "410",
  },
  {
    value: "410019",
    text: "410019 - Exclusão da gorjeta na base de cálculo no fornecimento de alimentação",
    cst: "410",
  },
  {
    value: "410020",
    text: "410020 - Exclusão do valor de intermediação na base de cálculo no fornecimento de alimentação",
    cst: "410",
  },
  {
    value: "410021",
    text: "410021 - Contribuição de que trata o art. 149-A da Constituição Federal",
    cst: "410",
  },
  {
    value: "410022",
    text: "410022 - Consolidação da propriedade do bem pelo credor",
    cst: "410",
  },
  {
    value: "410023",
    text: "410023 - Alienação de bens móveis ou imóveis que tenham sido objeto de garantia em que o prestador da garantia não seja contribuinte",
    cst: "410",
  },
  {
    value: "410024",
    text: "410024 - Consolidação da propriedade do bem pelo grupo de consórcio",
    cst: "410",
  },
  {
    value: "410025",
    text: "410025 - Alienação de bem que tenha sido objeto de garantia em que o prestador da garantia não seja contribuinte",
    cst: "410",
  },
  {
    value: "410026",
    text: "410026 - Doação com anulação de crédito",
    cst: "410",
  },
  {
    value: "410027",
    text: "410027 - Exportação de serviço ou de bem imaterial",
    cst: "410",
  },
  {
    value: "410028",
    text: "410028 - Operações com bens imóveis realizadas por pessoas físicas não consideradas contribuintes",
    cst: "410",
  },
  {
    value: "410029",
    text: "410029 - Operações acobertadas somente pelo ICMS",
    cst: "410",
  },
  {
    value: "410030",
    text: "410030 - Estorno de crédito por perecimento, deteriorização, roubo, furto ou extravio.",
    cst: "410",
  },
  {
    value: "410031",
    text: "410031 - Fornecimento em período anterior ao início de vigência de incidências de CBS e IBS",
    cst: "410",
  },
  {
    value: "410999",
    text: "410999 - Operações não onerosas sem previsão de tributação, não especificadas anteriormente",
    cst: "410",
  },
  {
    value: "510001",
    text: "510001 - Operações, sujeitas a diferimento, com energia elétrica, relativas à geração, comercialização, distribuição e transmissão",
    cst: "510",
  },
  {
    value: "515001",
    text: "515001 - Operações, sujeitas a diferimento, com insumos agropecuários e aquícolas (Anexo IX)",
    cst: "515",
  },
  {
    value: "550001",
    text: "550001 - Exportações de bens materiais",
    cst: "550",
  },
  {
    value: "550002",
    text: "550002 - Regime de Trânsito",
    cst: "550",
  },
  {
    value: "550003",
    text: "550003 - Regimes de Depósito (art. 85)",
    cst: "550",
  },
  {
    value: "550004",
    text: "550004 - Regimes de Depósito (art. 87)",
    cst: "550",
  },
  {
    value: "550005",
    text: "550005 - Regimes de Depósito (art. 87, Parágrafo único)",
    cst: "550",
  },
  {
    value: "550006",
    text: "550006 - Regimes de Permanência Temporária",
    cst: "550",
  },
  {
    value: "550007",
    text: "550007 - Regimes de Aperfeiçoamento",
    cst: "550",
  },
  {
    value: "550008",
    text: "550008 - Importação de bens para o Regime de Repetro-Temporário",
    cst: "550",
  },
  {
    value: "550009",
    text: "550009 - GNL-Temporário",
    cst: "550",
  },
  {
    value: "550010",
    text: "550010 - Repetro-Permanente",
    cst: "550",
  },
  {
    value: "550011",
    text: "550011 - Repetro-Industrialização",
    cst: "550",
  },
  {
    value: "550012",
    text: "550012 - Repetro-Nacional",
    cst: "550",
  },
  {
    value: "550013",
    text: "550013 - Repetro-Entreposto",
    cst: "550",
  },
  {
    value: "550014",
    text: "550014 - Zona de Processamento de Exportação",
    cst: "550",
  },
  {
    value: "550015",
    text: "550015 - Regime Tributário para Incentivo à Modernização e à Ampliação da Estrutura Portuária",
    cst: "550",
  },
  {
    value: "550016",
    text: "550016 - Regime Especial de Incentivos para o Desenvolvimento da Infraestrutura",
    cst: "550",
  },
  {
    value: "550017",
    text: "550017 - Regime Tributário para Incentivo à Atividade Econômica Naval",
    cst: "550",
  },
  {
    value: "550018",
    text: "550018 - Desoneração da aquisição de bens de capital",
    cst: "550",
  },
  {
    value: "550019",
    text: "550019 - Importação de bem material por indústria incentivada para utilização na ZFM",
    cst: "550",
  },
  {
    value: "550020",
    text: "550020 - Áreas de livre comércio",
    cst: "550",
  },
  {
    value: "550021",
    text: "550021 - Industrialização destinada a exportações",
    cst: "550",
  },
  {
    value: "620001",
    text: "620001 - Tributação monofásica sobre combustíveis",
    cst: "620",
  },
  {
    value: "620002",
    text: "620002 - Tributação monofásica com responsabilidade pela retenção sobre combustíveis",
    cst: "620",
  },
  {
    value: "620003",
    text: "620003 - Tributação monofásica com tributos retidos por responsabilidade sobre combustíveis",
    cst: "620",
  },
  {
    value: "620004",
    text: "620004 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual superior ao obrigatório",
    cst: "620",
  },
  {
    value: "620005",
    text: "620005 - Tributação monofásica sobre mistura de EAC com gasolina A em percentual inferior ao obrigatório",
    cst: "620",
  },
  {
    value: "620006",
    text: "620006 - Tributação monofásica sobre combustíveis cobrada anteriormente",
    cst: "620",
  },
  {
    value: "800001",
    text: "800001 - Fusão, cisão ou incorporação",
    cst: "800",
  },
  {
    value: "800002",
    text: "800002 - Transferência de crédito do associado, inclusive as cooperativas singulares",
    cst: "800",
  },
  {
    value: "810001",
    text: "810001 - Crédito presumido sobre o valor apurado nos fornecimentos a partir da ZFM",
    cst: "810",
  },
  {
    value: "811001",
    text: "811001 - Anulação de Crédito por Saídas Imunes/Isentas",
    cst: "811",
  },
  {
    value: "811002",
    text: "811002 - Débitos de notas fiscais não processadas na apuração",
    cst: "811",
  },
  {
    value: "811003",
    text: "811003 - Desenquadramento do Simples Nacional",
    cst: "811",
  },
  {
    value: "820001",
    text: "820001 - Documento com informações de fornecimento de serviços de planos de assinstência à saúde",
    cst: "820",
  },
  {
    value: "820002",
    text: "820002 - Documento com informações de fornecimento de serviços de planos de assinstência funerária",
    cst: "820",
  },
  {
    value: "820003",
    text: "820003 - Documento com informações de fornecimento de serviços de planos de assinstência à saúde de animais domésticos",
    cst: "820",
  },
  {
    value: "820004",
    text: "820004 - Documento com informações de prestação de serviços de consursos de prognósticos",
    cst: "820",
  },
  {
    value: "820005",
    text: "820005 - Documento com informações de alienação de bens imóveis",
    cst: "820",
  },
  {
    value: "820006",
    text: "820006 - Documento com informações de fornecimento de serviços de exploração de via",
    cst: "820",
  },
  {
    value: "820007",
    text: "820007 - Documento com informações de fornecimento de serviços financeiros",
    cst: "820",
  },
  {
    value: "820008",
    text: "820008 - Documento com informações de fornecimento, mas com tributação realizada em fatura anterior",
    cst: "820",
  },
  {
    value: "830001",
    text: "830001 - Documento com exclusão da BC da CBS e do IBS de energia elétrica fornecida pela distribuidora à UC",
    cst: "830",
  },
];

const optionsCstIbsCbs = [
  { value: "", text: "-- Selecione uma opção --" },
  { value: "000", text: "000 - Tributação integral" },
  { value: "010", text: "010 - Tributação com alíquotas uniformes" },
  { value: "011", text: "011 - Tributação com alíquotas uniformes reduzidas" },
  { value: "200", text: "200 - Alíquota reduzida" },
  { value: "220", text: "220 - Alíquota fixa" },
  { value: "221", text: "221 - Alíquota fixa proporcional" },
  { value: "222", text: "222 - Redução de Base de Cálculo" },
  { value: "400", text: "400 - Isenção" },
  { value: "410", text: "410 - Imunidade e não incidência" },
  { value: "510", text: "510 - Diferimento" },
  { value: "515", text: "515 - Diferimento com redução de alíquota" },
  { value: "550", text: "550 - Suspensão" },
  { value: "620", text: "620 - Tributação Monofásica" },
  { value: "800", text: "800 - Transferência de crédito" },
  { value: "810", text: "810 - Ajuste de IBS na ZFM" },
  { value: "811", text: "811 - Ajustes" },
  { value: "820", text: "820 - Tributação em declaração de regime específico" },
  { value: "830", text: "830 - Exclusão da Base de Cálculo" },
];

const optionsCredPresumido = [
  { value: null, text: "-- Selecione uma opção --" },
  {
    value: "01",
    text: "01 - Crédito presumido da aquisição de bens e serviços de produtor rural e produtor rural integrado não contribuinte, observado o art. 168 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "02",
    text: "02 - Crédito presumido da aquisição de serviço de transportador autônomo de carga pessoa física não contribuinte, observado o art. 169 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "03",
    text: "03 - Crédito presumido da aquisição de resíduos e demais materiais destinados à reciclagem, reutilização ou logística reversa adquiridos de pessoa física, cooperativa ou outra forma de organização popular, observado o art. 170 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "04",
    text: "04 - Crédito presumido da aquisição de bens móveis usados de pessoa física não contribuinte para revenda, observado o art. 171 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "05",
    text: "05 - Crédito presumido no regime automotivo, observado o art. 311 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "06",
    text: "06 - Crédito presumido no regime automotivo, observado o art. 312 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "07",
    text: "07 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 444 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "08",
    text: "08 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 447 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "09",
    text: "09 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 449 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "10",
    text: "10 - Crédito presumido na aquisição por contribuinte na Zona Franca de Manaus, observado o art. 450 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "11",
    text: "11 - Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 462 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "12",
    text: "12 - Crédito presumido na aquisição por contribuinte na Área de Livre Comércio, observado o art. 465 da Lei Complementar nº 214, de 2025.",
  },
  {
    value: "13",
    text: "13 - Crédito presumido na aquisição pela indústria na Área de Livre Comércio, observado o art. 467 da Lei Complementar nº 214, de 2025.",
  },
];

// usa o mesmo catálogo:
const optionsClassTribBase = optionsClassTribIbsCbs; // 👈 reaproveita
const optionsCstBase = optionsCstIbsCbs; // 👈 se for igual

export default {
  name: "app-produtos-form",
  props: {
    url: {
      type: String,
    },
    produto: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Money,
    VueSelect,
    Quest,
    Plus,
    TableApp,
    Pencil,
    TrashCanIcon,
    ModalProduto,
    SearchWeb,
    InformationOutline,
  },
  mixins: [validationMixin, SistemaMixin],
  data() {
    return {
      onboardStore,
      windowWidth: window.innerWidth,
      produtoSelected: null,
      variacoesFetched1: [],
      variacoesFetched2: [],
      combinacao: [],
      tabIndex: 0,
      quantityOptions,
      variacaoSelected1: null,
      variacaoSelected2: null,
      priceOptions,
      urlProdutoImage: null,
      produtoImageWasRemoved: false,
      isVariavel: false,
      keyToRender: 0,
      modalProdutoIsOpen: false,
      produtos: [],
      produtoToEdit: null,
      preco: 0,
      total: 0,
      quantidade: 1,
      tipos: [],
      configMoney: settingMoney,
      form: {},
      unidadeMedida: [],
      grupos: [],
      cfops: [],
      isComposto: false,
      cests: [],
      cstcsosns: [],
      tributacoes: [],
      ncms: [],
      tributacao: null,
      cfop: null,
      cest: null,
      ncm: null,
      cstcsosn: null,
      cenqs: [],
      cenq: null,
      cstipis: [],
      cstipi: null,
      cstspis: [],
      cstpis: null,
      fcp: null,
      anps: [],
      anp: null,
      cstscofins: [],
      cstcofins: null,
      produtosFetched: [],
      icmEntrada: 0,
      icmSaida: 0,
      custoOperacional: 0,
      outrosImpostos: 0,
      comissao: 0,
      lucro: 0,
      valorVendaSugerido: 0,
      recalCulateValorVenda: 0,
      fornecedor: null,
      fornecedores: [],
      cfop_nfce: null,
      cfops_nfce: [],
      cstcsosnContribuinte: null,
      tributacaoST: null,
      perfilTributario: null,
      perfisTributarios: [],
      perfilTributarioSelecionado: false,
      grupo: null,
      fields: [
        {
          label: "Item/Cód",
          field: "item",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Qtd",
          field: "quantidade",
          slot: true,
          sortable: false,
          width: "8%",
        },
        {
          label: "Custo unitário",
          field: "preco",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Total",
          field: "total",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
        },
      ],
      isPerca: false,
      isLote: false,
      isRestaurante: false,
      restauranteSemPreparo: false,
      restauranteDestinos: [],
      produtoSelectedPerca: null,
      origens: [
        {
          id: 0,
          descricao: "0 - Nacional, exceto as indicadas nos códigos 3 a 5",
        },
        {
          id: 1,
          descricao:
            "1 - Estrangeira - Importação direta, exceto a indicada no código 6",
        },
        {
          id: 2,
          descricao:
            "2 - Estrangeira - Adquirida no mercado interno, exceto a indicada no código 7",
        },
        {
          id: 3,
          descricao:
            "3 - Nacional, mercadoria ou bem com Conteúdo de Importação superior a 40%",
        },
        {
          id: 4,
          descricao:
            "4 - Nacional, cuja produção tenha sido feita em conformidade com os processos produtivos básicos de que tratam o Decreto-Lei nº 288/1967.",
        },
        {
          id: 5,
          descricao:
            "5 - Nacional, mercadoria ou bem com Conteúdo de Importação inferior ou igual a 40%",
        },
        {
          id: 6,
          descricao:
            "6 - Estrangeira - Importação direta, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 7,
          descricao:
            "7 - Estrangeira - Adquirida no mercado interno, sem similar nacional, constante em lista de Resolução Camex e gás natural",
        },
        {
          id: 8,
          descricao:
            "8 – Nacional: mercadoria ou bem com Conteúdo de Importação superior a 70%;",
        },
      ],
      novoLote: {
        numero_lote: "",
        data_fabricacao: "",
        data_validade: "",
        quantidade: null,
      },
      campos: [
        { key: "numero_lote", label: "Lote" },
        { key: "data_fabricacao", label: "Fabricação" },
        { key: "data_validade", label: "Validade" },
        { key: "quantidade", label: "Quantidade" },
        { key: "acoes", label: "Ações" },
      ],
      lotes: [],
      loteSelecionado: {},
      indiceSelecionado: null,
      selectedCombinacoes: [],
      selectAllCombinacoes: false,
      optionsCstIs: [],
      optionsClassTribIs: [],
      optionsCstIbsCbsArr: optionsCstIbsCbs,
      optionsCstRegular: optionsCstBase,
      optionsCodCredPresumido: optionsCredPresumido,
    };
  },
  validations: {
    form: ProdutoDataRequired,
  },
  watch: {
    produto: {
      immediate: true,
      handler(newValue, oldValue) {
        if (!newValue || newValue === oldValue) {
          return;
        }

        this.form = this.getProdutoFormNormalizado(newValue);
        this.isVariavel = newValue?.variavel ?? false;
        this.isPerca = newValue?.perca ?? false;
        this.isLote = newValue?.lote ?? false;
        this.isRestaurante = newValue?.restaurante ?? false;
        this.restauranteSemPreparo = newValue?.restaurante_sem_preparo ?? false;
        this.restauranteDestinos = this.getRestauranteDestinos(newValue);
        if (newValue?.combinacao?.length > 0)
          this.combinacao = newValue.combinacao;

        if (newValue?.lotes?.length > 0) this.lotes = newValue.lotes;
        this.tributacao = newValue.tributacao ?? null;
        this.form.data_ultima_venda = this.formatDate(
          newValue.data_ultima_venda
        );
        this.urlProdutoImage = this.form.imagem;
        this.produtoImageWasRemoved = false;
        this.isComposto = newValue.composto;
        this.produtos = this.formatarComposicaoProduto(newValue.composicao);
        this.keyToRender = this.keyToRender + 1;
        this.form.peso = this.formatNumberToFloat(newValue.peso);
        this.cfop = newValue.cfop ?? null;
        this.cest = newValue.cest ?? null;
        this.ncm = newValue.ncm ?? null;
        this.cstcsosn = newValue.cst_csosn ?? null;
        this.cenq = newValue.cenq ?? null;
        this.cstipi = newValue.cst_ipi ?? null;
        this.cstpis = newValue.cst_pis ?? null;
        this.fcp = newValue.fcp ?? null;
        this.anp = newValue.anp ?? null;
        this.cstcofins = newValue.cst_cofins ?? null;
        this.fornecedor = newValue.fornecedor ?? null;
        this.grupo = newValue.grupo ?? null;
        this.cfop_nfce = newValue.cfop_nfce ?? null;
        this.form.data_ultima_compra = this.formatDate(
          newValue.data_ultima_compra
        );
        this.cstcsosnContribuinte = newValue.cst_csosn_contribuinte ?? null;
        this.tributacaoST = newValue.tributacao_s_t ?? null;
        this.perfilTributario = newValue.perfil_tributario ?? null;
        // Resetar flag de perfil selecionado
        this.perfilTributarioSelecionado = newValue.perfil_tributario
          ? true
          : false;
        // Se houver um perfil tributário, preencher os campos
        if (newValue.perfil_tributario && newValue.perfil_tributario.id) {
          this.setPerfilTributario(newValue.perfil_tributario);
        }
        this.produtoSelectedPerca = newValue.perca_produto?.produto ?? null;
        this.form.perca_percentual = newValue.perca_produto?.perca ?? 0;
        this.form.baixa_automatica_lote =
          newValue.baixa_automatica_lote ?? false;
      },
    },
    selectedCombinacoes(newVal) {
      if (!this.combinacao.length) {
        this.selectAllCombinacoes = false;
        return;
      }
      this.selectAllCombinacoes = newVal.length === this.combinacao.length;
    },
    quantidade() {
      this.atualizarTotalComposicao();
    },
    preco() {
      this.atualizarTotalComposicao();
    },
    //eslint-disable-next-line no-unused-vars
    "form.custo"(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    icmEntrada(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    icmSaida(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    custoOperacional(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    outrosImpostos(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    comissao(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    //eslint-disable-next-line no-unused-vars
    lucro(value) {
      setTimeout(() => {
        this.valorVendaSugerido =
          (this.custoUnitario / ((100 - this.allPercentages) / 100)) *
          (1 + this.lucro / 100);
      }, 100);
    },
    "form.class_trib_ibs_cbs"(val) {
      if (!val) {
        this.form.cst_ibs_cbs = ""; // <-- era null
        return;
      }

      const found = optionsClassTribIbsCbs.find((i) => i.value === val);
      this.form.cst_ibs_cbs = found?.cst ?? ""; // <-- sempre string
    },
    "form.cst_ibs_cbs"(val) {
      if (!val) return; // cobre null e ""
      const s = String(val).padStart(3, "0");
      if (s !== val) this.form.cst_ibs_cbs = s;
    },
    "form.class_trib_regular"(val) {
      if (!val) {
        this.form.cst_regular = null;
        return;
      }

      const found = optionsClassTribBase.find((i) => i.value === val);
      this.form.cst_regular = found?.cst ?? null;
    },

    "form.cst_regular"(val) {
      if (val == null || val === "") return;

      // se o CST regular for 3 dígitos igual IBS/CBS:
      const s = String(val).padStart(3, "0");
      if (s !== val) this.form.cst_regular = s;
    },
  },
  computed: {
    ...mapGetters(["itsblocked"]),
    custosOpera() {
      return this.custoOperacional || 0;
    },
    calcLucro() {
      return (this.lucro || 0) + (this.comissao || 0);
    },
    impostosNFe() {
      return (this.icmSaida || 0) + (this.outrosImpostos || 0);
    },
    impostoEntrada() {
      return this.icmEntrada || 0;
    },
    allPercentages() {
      return (
        (this.icmEntrada || 0) -
        (this.icmSaida || 0) +
        (this.custoOperacional || 0) +
        (this.outrosImpostos || 0) +
        (this.lucro || 0) +
        (this.comissao || 0)
      );
    },
    valorVendaCalculado() {
      const fatorCustoOepracao = this.custosOpera / 100;
      const fatorLucro = this.calcLucro / 100;
      const fatorImpostoVenda = this.impostosNFe / 100;
      const fatorImpostoEntrada = this.impostoEntrada / 100;

      const custo = this.form.custo + this.form.custo * fatorCustoOepracao;
      const custoLucro = custo + custo * fatorLucro;
      const custoImpo = custoLucro + custoLucro * fatorImpostoVenda;
      const custoFinal = custoImpo - custoImpo * fatorImpostoEntrada;

      return custoFinal;
    },
    custoUnitario() {
      return this.form.custo;
    },
    totalItensComposicao() {
      if (this.produtos.length > 0) {
        let quantidade = 0;
        this.produtos.forEach((produto, index) => {
          quantidade += parseFloat(produto.product.quantidade);
        });

        return quantidade;
      }

      return 0;
    },
    optionsClassTribIbsCbsFiltered() {
      const cst = this.form.cst_ibs_cbs
        ? String(this.form.cst_ibs_cbs).padStart(3, "0")
        : "";

      const list = cst
        ? optionsClassTribIbsCbs.filter((i) => i.cst === cst)
        : optionsClassTribIbsCbs;

      return [
        { value: "", text: "-- Selecione uma opção --" },
        ...list.map((i) => ({ value: i.value, text: i.text })),
      ];
    },
    optionsClassTribRegularFiltered() {
      const cst =
        this.form.cst_regular == null
          ? null
          : String(this.form.cst_regular).padStart(3, "0");

      const list = cst
        ? optionsClassTribBase.filter((i) => i.cst === cst)
        : optionsClassTribBase;

      return [
        { value: null, text: "-- Selecione uma opção --" },
        ...list.map((i) => ({ value: i.value, text: i.text })),
      ];
    },
  },
  created() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    this.getDataInit();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    toggleSelectAllCombinacoes() {
      if (this.selectAllCombinacoes) {
        // Seleciona todas
        this.selectedCombinacoes = [...this.combinacao];
      } else {
        // Limpa seleção
        this.selectedCombinacoes = [];
      }
    },
    async removerCombinacoesSelecionadas() {
      if (this.selectedCombinacoes.length === 0) return;

      // Confirmação (BootstrapVue)
      const confirmar = await this.$bvModal.msgBoxConfirm(
        `Deseja realmente remover ${this.selectedCombinacoes.length} variação(ões) selecionada(s)?`,
        {
          title: "Confirmar remoção",
          okTitle: "Sim, remover",
          cancelTitle: "Cancelar",
          centered: true,
          size: "sm",
          okVariant: "danger",
        }
      );

      if (!confirmar) {
        return;
      }

      // Remove as combinações selecionadas
      this.combinacao = this.combinacao.filter(
        (item) => !this.selectedCombinacoes.includes(item)
      );

      // Limpa seleção
      this.selectedCombinacoes = [];
      this.selectAllCombinacoes = false;
    },
    async searchCodigoBarra() {
      if (!this.form.cod_barras) {
        this.$toast.warning(
          "Informe o código de barras para realizar a consulta."
        );
        return;
      }

      const { data } = await this.$http.post("produtos/consulta-cod-barra", {
        cod_barras: this.form.cod_barras,
      });

      if (data.Marca) {
        this.form.marca = data.Marca;
      }

      if (data.Nome) {
        this.form.descricao = data.Nome;
      }

      if (data.Ncm) {
        this.setNCM(data.Ncm);
      }

      if (data.Cest_Codigo) {
        this.setCEST(data.Cest_Codigo);
      }

      // const dataFoto = await this.$http.post("produtos/consulta-foto", {
      //   cod_barras: this.form.cod_barras,
      // });
      // var b = Buffer.from(dataFoto.data).toString("base64");
      // const blob = new Blob([dataFoto.data]);
      // var foto = new File([blob], "foto.png", { type: "image/png" });
      // this.form.imagem = foto;
      // console.log(foto);
      // this.urlProdutoImage =
      //   "http://www.eanpictures.com.br:9000/api/gtin/" + this.form.cod_barras;

      this.$toast.success(
        "Produto consultado com sucesso, verifique os dados."
      );
      return;
    },
    formatVariacao(item) {
      if (!isNaN(parseFloat(item)) && isFinite(item)) {
        return;
      }
      return item;
    },
    setAtivo() {
      this.form.ativo = !this.form.ativo;
    },
    selectFiles() {
      document.getElementById("fileUpload").click();
    },
    setProdutoImage(event) {
      if (!event.target.files.length) return;

      this.produtoImageWasRemoved = false;
      this.form.imagem = event.target.files[0];
      this.urlProdutoImage = URL.createObjectURL(this.form.imagem);
    },
    removeProdutoImage() {
      this.form.imagem = null;
      this.urlProdutoImage = null;
      this.produtoImageWasRemoved = true;

      if (this.$refs.fileUpload) {
        this.$refs.fileUpload.value = "";
      }
    },
    comboKey(combo) {
      return Object.keys(combo)
        .filter((k) => k !== "quantidade")
        .map((k) => {
          const v = combo[k];
          if (v && typeof v === "object") {
            // tenta priorizar identificadores previsíveis
            return `${k}:${
              v.id_variavel_valor ??
              v.id_valor ??
              v.id ??
              v.codigo ??
              v.nome ??
              JSON.stringify(v)
            }`;
          }
          return `${k}:${v}`;
        })
        .sort() // evita diferença de ordem das chaves
        .join("|");
    },

    // 2) ALTERADO: agora mescla sem perder as que já existem
    async mesclarVariacoes() {
      this.addLoadingToButton("mesclar_button");

      if (!this.variacaoSelected1 && !this.variacaoSelected2) {
        this.$toast.warning("Selecione alguma variação para prosseguir.");
        this.removeLoadingToButton("mesclar_button");
        return;
      }

      const variaveis = [];
      if (this.variacaoSelected1)
        variaveis.push({ id_variavel: this.variacaoSelected1.id_variavel });
      if (this.variacaoSelected2)
        variaveis.push({ id_variavel: this.variacaoSelected2.id_variavel });

      try {
        const { data: novasCombinacoes } = await this.$http.post(
          "/variavel/mesclar",
          { variaveis }
        );

        // Mapa das combinações existentes preservando as quantidades
        const existentesByKey = new Map(
          (this.combinacao || []).map((c) => [this.comboKey(c), c])
        );

        // Começa mantendo tudo que já existe (preserva quantidade)
        const merged = [...(this.combinacao || [])];

        // Adiciona somente as novas que ainda não existem
        for (const nova of novasCombinacoes || []) {
          const key = this.comboKey(nova);
          if (!existentesByKey.has(key)) {
            merged.push({
              ...nova,
              // define quantidade padrão para novas combinações
              quantidade:
                typeof nova.quantidade === "number" ? nova.quantidade : 0,
            });
          }
        }

        this.combinacao = merged;

        this.$toast.success(
          "Variações mescladas sem perder quantidades existentes."
        );
      } catch {
        this.$toast.error(
          "Não foi possível mesclar as variações. Tente novamente."
        );
      } finally {
        this.removeLoadingToButton("mesclar_button");
      }
    },
    openModalProduto(produtoData, currentIndex) {
      this.modalProdutoIsOpen = true;
      this.produtoToEdit = {
        ...produtoData.product,
        currentIndex,
        quantidade: this.formatNumberToFloat(produtoData.product.quantidade),
        preco: this.formatNumberToFloat(produtoData.product.custo),
      };
    },

    closeModalProduto() {
      this.modalProdutoIsOpen = false;
    },
    atualizarTotalComposicao() {
      this.total =
        this.formatNumberToFloat(this.quantidade) *
        this.formatNumberToFloat(this.preco);
    },
    formatarComposicaoProduto(composicao = []) {
      return composicao.map((item, index) => ({
        product: {
          ...item.produto,
          quantidade: item.quantidade,
        },
        active: true,
        currentIndex: index,
        preco: item.produto.custo,
        quantidade: item.quantidade,
        totalPrice:
          this.formatNumberToFloat(item.produto.custo) *
          this.formatNumberToFloat(item.quantidade),
      }));
    },
    async saveEditProduto(newEditedProduto) {
      const aux = _.cloneDeep(this.produtos);
      aux.splice(newEditedProduto.currentIndex, 1, {
        ...this.produtos[newEditedProduto.currentIndex],
        product: {
          ...newEditedProduto,
          custo: newEditedProduto.preco,
        },
        preco: newEditedProduto.preco,
        quantidade: newEditedProduto.quantidade,
        totalPrice: newEditedProduto.preco * newEditedProduto.quantidade,
      });
      this.produtos = aux;
    },
    handleEnter(ref) {
      if (this.fromSelect) {
        this.fromSelect = false;
        return;
      }
      if (!this.$refs[ref]) return;
      this.$refs[ref].$el.focus();
    },
    handleDeleteProduto(item) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o produto " + item.product.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const aux = this.produtos
              .filter((produto, index) => index !== item.originalIndex)
              .map((item, index) => ({
                ...item,
                product: { ...item.product, currentIndex: index },
              }));
            this.produtos = _.cloneDeep(aux);
          }
        });
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    setProduto(produto) {
      if (!produto) return;
      this.descricao = produto.descricao;
      this.estoqueProduto = produto.quantidade;
      this.quantidade = 1;

      this.preco = parseFloat(produto.custo || 0);

      this.total = this.quantidade * parseFloat(this.preco);
      this.produtoSelected = {
        ...produto,
        preco: this.preco,
        custo: this.preco,
        quantidade: this.quantidade,
        tipo_atacado: false,
      };
      this.produtoSelected.total = this.total;

      this.produtoFilled = true;
      this.fromSelect = true;
      this.$nextTick(() => {
        this.$refs.quantidade.$el.focus();
      });
    },
    async addProduto(produto) {
      if (_.isEmpty(produto)) return;
      let produtoJaAdd = false;

      if (this.produtos.length > 0) {
        this.produtos.forEach((product, index) => {
          if (product.product.id === produto.id) {
            this.$toast.warning(
              "O item: " +
                produto.descricao +
                " já foi adicionado na composição, verifique"
            );
            produtoJaAdd = true;
          }
        });
      }

      if (produtoJaAdd) return;

      const produtoFormatted = {
        ...produto,
        preco: this.preco,
        custo: this.preco,
        quantidade: parseFloat(this.quantidade),
        total: this.preco * this.quantidade,
      };
      this.produtos = [
        ...this.produtos,
        {
          product: produtoFormatted,
          active: true,
          currentIndex: this.produtos.length,
          totalPrice: this.preco * this.quantidade,
          quantidade: parseFloat(this.quantidade),
        },
      ];

      this.$nextTick(() => {
        this.$refs.buscarProduto.$refs.search.focus();
      });
      this.produtoSelected = null;
      this.resetInputs();
    },
    resetInputs() {
      this.quantidade = 1;
      this.preco = 0;
      this.total = 0;
    },
    onSearchProduto(search, loading) {
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchProdutos(loading, search, this);
      }
    },
    searchProdutos: _.debounce(async (loading, search, vm) => {
      vm.produtosFetched = await vm.fetchProdutos(search, vm.typeFilter);
      loading(false);
    }, 350),

    onSearchVariacao(search, loading, type) {
      if (search.length > 2) {
        loading(true);
        this.searchVariacao(loading, search, this, type);
      }
    },
    searchVariacao: _.debounce(async (loading, search, vm, type) => {
      const { data } = await vm.$http.post("/variavel/get-variaveis", {
        nome: search,
      });
      if (type === 1) vm.variacoesFetched1 = [...data];
      if (type === 2) vm.variacoesFetched2 = [...data];
      loading(false);
    }, 350),
    setComposto() {
      this.isComposto = !this.isComposto;
    },
    resetAssistentePreco() {
      this.icmEntrada = 0;
      this.icmSaida = 0;
      this.custoOperacional = 0;
      this.lucro = 0;
      this.outrosImpostos = 0;
      this.comissao = 0;
    },
    async getAssistentePreco() {
      const { data } = await this.$http.post("produtos/get-assistente-preco", {
        id_produto: this.produto.id,
      });

      if (data) {
        this.icmEntrada = parseFloat(data?.icm_entrada);
        this.icmSaida = parseFloat(data?.icm_saida);
        this.custoOperacional = parseFloat(data?.custo_operacional);
        this.lucro = parseFloat(data?.lucro);
        this.outrosImpostos = parseFloat(data?.outros_impostos);
        this.comissao = parseFloat(data?.comissao);

        this.$nextTick(() => {
          const fatorReducao = this.allPercentages / 100;
          this.valorVendaSugerido =
            this.form.custo + this.form.custo * fatorReducao;
        });
      }
    },
    salvarValorVenda() {
      const fatorCustoOepracao = this.custosOpera / 100;
      const fatorLucro = this.calcLucro / 100;
      const fatorImpostoVenda = this.impostosNFe / 100;
      const fatorImpostoEntrada = this.impostoEntrada / 100;

      const custo = this.form.custo + this.form.custo * fatorCustoOepracao;
      const custoLucro = custo + custo * fatorLucro;
      const custoImpo = custoLucro + custoLucro * fatorImpostoVenda;
      const custoFinal = custoImpo - custoImpo * fatorImpostoEntrada;

      this.form.preco = custoFinal;

      this.$bvModal.hide("modal-assistant");
      this.$toast.success("Valor sugerido aplicado com sucesso");

      this.$http.post("/produtos/create-assistente-preco", {
        id_produto: this.produto.id,
        custo: this.form.custo,
        icmEntrada: this.icmEntrada,
        icmSaida: this.icmSaida,
        custoOperacional: this.custoOperacional,
        outrosImpostos: this.outrosImpostos,
        comissao: this.comissao,
        lucro: this.lucro,
        valorVendaSugerido: this.form.preco,
      });
    },
    setPesado() {
      this.form.pesado = this.form.pesado == true ? false : true;
    },
    setRestaurante() {
      if (!this.isRestaurante) {
        this.restauranteDestinos = [];
        this.restauranteSemPreparo = false;
        return;
      }

      if (!this.restauranteDestinos.length && !this.restauranteSemPreparo) {
        this.restauranteDestinos = ["cozinha"];
      }
    },
    setRestauranteSemPreparo() {
      if (this.restauranteSemPreparo) {
        this.restauranteDestinos = [];
      } else if (this.isRestaurante && !this.restauranteDestinos.length) {
        this.restauranteDestinos = ["cozinha"];
      }
    },
    hasRestauranteDestino(destino) {
      return this.restauranteDestinos.includes(destino);
    },
    toggleRestauranteDestino(destino) {
      if (this.hasRestauranteDestino(destino)) {
        this.restauranteDestinos = this.restauranteDestinos.filter(
          (item) => item !== destino
        );
        return;
      }

      this.restauranteDestinos = [...this.restauranteDestinos, destino];
    },
    getRestauranteDestinos(produto) {
      if (Array.isArray(produto?.restaurante_destinos)) {
        return produto.restaurante_destinos;
      }

      if (Array.isArray(produto?.restaurante_setores)) {
        return produto.restaurante_setores
          .map((vinculo) => vinculo.setor_producao?.tipo)
          .filter((destino) => ["cozinha", "bar"].includes(destino));
      }

      return [];
    },
    adicionarLote() {
      if (
        this.novoLote.numero_lote &&
        this.novoLote.data_fabricacao &&
        this.novoLote.data_validade
      ) {
        this.lotes.push({ ...this.novoLote });

        // Limpar o formulário
        this.novoLote = {
          numero_lote: "",
          data_fabricacao: "",
          data_validade: "",
          quantidade: 0,
        };
        this.$toast.success("Lote adicionado com sucesso");
      } else {
        this.$toast.warning("Verifique as informações");
      }
    },
    confirmarRemocao(index, lote) {
      this.indiceSelecionado = index;
      this.loteSelecionado = { ...lote };

      // Exibir o modal de confirmação
      this.$refs.modalConfirmar.show();
    },
    removerLoteConfirmado() {
      if (this.indiceSelecionado !== null) {
        this.lotes.splice(this.indiceSelecionado, 1);
        this.$toast.success("Lote removido com sucesso");

        this.$refs.modalConfirmar.hide();
      }
    },
    async getDataInit() {
      this.form = new ProdutosData({});
      this.getUnidadeMedidas().then((data) => (this.unidadeMedida = data));
      this.getCstCsosn().then((data) => (this.cstcsosns = data));
      this.getTributacao().then((data) => (this.tributacoes = data));
      this.getCenqByCodigo().then((data) => (this.cenqs = data));
      this.getCSTIPIByCodigo().then((data) => (this.cstipis = data));
      this.getCSTPISByCodigo().then((data) => (this.cstspis = data));
      this.getAnpByCodigo().then((data) => (this.anps = data));
      this.getCSTCofinsByCodigo().then((data) => (this.cstscofins = data));
      if (this.produto.id) {
        this.form = this.getProdutoFormNormalizado(this.produto);
        this.isComposto = this.produto.composto;
        this.isPerca = this.produto.perca;
        this.isLote = this.produto.lote;
        this.isRestaurante = this.produto.restaurante;
        this.restauranteSemPreparo =
          this.produto.restaurante_sem_preparo ?? false;
        this.restauranteDestinos = this.getRestauranteDestinos(this.produto);
        this.produtos = this.formatarComposicaoProduto(this.produto.composicao);
        this.produtoSelectedPerca = this.produto.perca_produto.produto;
        this.setCFOP(this.produto.cfop);
        this.setCEST(this.produto.cest);
        this.setNCM(this.produto.ncm);
        this.setCSTCSOSN(this.produto.cst_csosn);
        this.setTributacao(this.produto.tributacao);
        this.setCSTIPI(this.produto.cst_ipi);
        this.setCSTPIS(this.produto.cst_pis);
        this.setCENQ(this.produto.cenq);
        this.setFCP(this.produto.fcp);
        this.setANP(this.produto.anp);
        this.setCSTCofins(this.produto.cst_cofins);
        this.setFornecedor(this.produto.fornecedor);
        this.setCFOPNFce(this.produto.cfop_nfce);
        this.setCSTCSOSNContribuinte(this.produto.cst_csosn_contribuinte);
        this.setTributacaoST(this.produto.tributacao_s_t);
        this.setGrupo(this.produto.grupo);
        this.setPerfilTributario(this.produto.perfil_tributario);
      }
      try {
        const { data } = await this.$http.post("/produtos/tipos");
        this.tipos = data;
        this.form.id_tipo = 1;
      } catch {
        this.$toast.error("Não foi possível carregar os tipos de produto.");
      }
    },
    setCFOPNFce(cfopnfce) {
      this.cfop_nfce = cfopnfce;
    },
    setFornecedor(fornecedor) {
      this.fornecedor = fornecedor;
    },
    setGrupo(grupo) {
      this.grupo = grupo;
    },
    setANP(anp) {
      this.anp = anp;
    },
    setFCP(fcp) {
      this.fcp = fcp;
    },
    setCSTPIS(cstpis) {
      this.cstpis = cstpis;
    },
    setCSTCofins(cstcofins) {
      this.cstcofins = cstcofins;
    },
    setCSTIPI(cstipi) {
      this.cstipi = cstipi;
    },
    setCENQ(cenq) {
      this.cenq = cenq;
    },
    setCFOP(cfop) {
      this.cfop = cfop;
    },
    setCEST(cest) {
      this.cest = cest;
    },
    setNCM(ncm) {
      this.ncm = ncm;
    },
    setCSTCSOSN(cstcsosn) {
      this.cstcsosn = cstcsosn;
    },
    setTributacao(tributacao) {
      this.tributacao = tributacao;
    },
    setTributacaoST(tributacao) {
      this.tributacaoST = tributacao;
    },
    setCSTCSOSNContribuinte(cstcsosn) {
      this.cstcsosnContribuinte = cstcsosn;
    },
    setProdutoPerca(produto) {
      this.produtoSelectedPerca = produto;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    setActivePreviousTab() {
      this.tabIndex = parseInt(localStorage.getItem("builderTab")) || 0;
      const links = this.$refs["builder-tab"].querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.$refs["builder-tab"]
        .querySelector(`[data-tab="${this.tabIndex}"]`)
        .classList.add("active");
    },
    setActiveTab(event) {
      const tab = event.target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".nav-link");

      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      this.tabIndex = parseInt(event.target.getAttribute("data-tab"));

      event.target.classList.add("active");
    },
    getProdutoFormNormalizado(produto) {
      return {
        ...produto,
        estoque_minimo: this.normalizarNumeroProdutoParaEnvio(
          produto.estoque_minimo
        ),
        preco: this.normalizarNumeroProdutoParaEnvio(produto.preco),
        preco_atacado: this.normalizarNumeroProdutoParaEnvio(
          produto.preco_atacado
        ),
        quantidade: this.normalizarNumeroProdutoParaEnvio(produto.quantidade),
        quantidade_atacado: this.normalizarNumeroProdutoParaEnvio(
          produto.quantidade_atacado
        ),
        ipi: this.normalizarNumeroProdutoParaEnvio(produto.ipi),
        pis: this.normalizarNumeroProdutoParaEnvio(produto.pis),
        cofins: this.normalizarNumeroProdutoParaEnvio(produto.cofins),
      };
    },
    normalizarNumeroProdutoParaEnvio(value) {
      if (
        value === null ||
        value === undefined ||
        value === "" ||
        value === "null"
      ) {
        return value;
      }

      return this.formatNumberToFloat(`${value}`);
    },
    getValorProdutoParaEnvio(key) {
      const value = this.form[key];

      if (!camposNumericosProduto.includes(key)) {
        return value;
      }

      return this.normalizarNumeroProdutoParaEnvio(value);
    },
    async salvarProduto(refLoading) {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) {
        this.$toast.error(
          "Verifique todos os campos obrigatórios do formulário!"
        );
        return null;
      }

      if (this.form.id_medida == null) {
        this.$toast.warning("Selecione uma unidade de medida!");
        return null;
      }

      if (
        this.isRestaurante &&
        !this.restauranteSemPreparo &&
        !this.restauranteDestinos.length
      ) {
        this.$toast.warning(
          "Selecione Cozinha, Bar ou Sem preparo para o produto restaurante."
        );
        return null;
      }

      this.addLoadingToButton(refLoading);

      this.form.composto = this.isComposto;
      this.form.variavel = this.isVariavel;
      this.form.perca = this.isPerca;
      this.form.lote = this.isLote;
      this.form.restaurante = this.isRestaurante;
      this.form.restaurante_sem_preparo =
        this.isRestaurante && this.restauranteSemPreparo;
      this.form.restaurante_destinos = this.isRestaurante
        ? this.restauranteSemPreparo
          ? []
          : this.restauranteDestinos
        : [];

      let produto = new FormData();

      if (this.cfop != null) {
        this.form.id_cfop = this.cfop.id_cfop;
      }
      if (this.cfop == null) {
        this.form.id_cfop = null;
      }
      if (this.cest != null) {
        this.form.id_cest = this.cest.id_cest;
      }
      if (this.cest == null) {
        this.form.id_cest = null;
      }
      if (this.ncm != null) {
        this.form.id_ncm = this.ncm.id_ncm;
      }
      if (this.ncm == null) {
        this.form.id_ncm = null;
      }
      if (this.cstcsosn != null) {
        this.form.id_cst_csosn = this.cstcsosn.id_cst_csosn;
      }
      if (this.cstcsosn == null) {
        this.form.id_cst_csosn = null;
      }
      if (this.tributacao != null) {
        this.form.id_tributacao = this.tributacao.id;
      }
      if (this.tributacao == null) {
        this.form.id_tributacao = null;
      }
      if (this.cenq != null) {
        this.form.id_cenq = this.cenq.id_cenq;
      }
      if (this.cenq == null) {
        this.form.id_cenq = null;
      }
      if (this.cstipi != null) {
        this.form.id_cstipi = this.cstipi.id_cstipi;
      }
      if (this.cstipi == null) {
        this.form.id_cstipi = null;
      }
      if (this.cstpis != null) {
        this.form.id_cstpis = this.cstpis.id_cstpis;
      }
      if (this.cstpis == null) {
        this.form.id_cstpis = null;
      }
      if (this.fcp != null) {
        this.form.id_fcp = this.fcp.id;
      }
      if (this.fcp == null) {
        this.form.id_fcp = null;
      }
      if (this.anp != null) {
        this.form.id_anp = this.anp.id_anp;
      }
      if (this.anp == null) {
        this.form.id_anp = null;
      }
      if (this.cstcofins != null) {
        this.form.id_cstcofins = this.cstcofins.id_cstcofins;
      }
      if (this.cstcofins == null) {
        this.form.id_cstcofins = null;
      }
      if (this.cstcofins == null) {
        this.form.id_cstcofins = null;
      }
      if (this.fornecedor != null) {
        this.form.id_pessoa = this.fornecedor.id_pessoa;
      }
      if (this.fornecedor == null) {
        this.form.id_pessoa = null;
      }
      if (this.grupo != null) {
        this.form.id_grupo = this.grupo.id;
      }
      if (this.grupo == null) {
        this.form.id_grupo = null;
      }

      if (this.perfilTributario != null) {
        this.form.id_perfil_tributario = this.perfilTributario.id;
      }
      if (this.perfilTributario == null) {
        this.form.id_perfil_tributario = null;
      }

      if (this.cfop_nfce != null) {
        this.form.id_cfop_nfce = this.cfop_nfce.id_cfop;
      }

      if (this.cfop_nfce == null) {
        this.form.id_cfop_nfce = null;
      }

      if (this.cstcsosnContribuinte != null) {
        this.form.id_cst_csosn_contribuinte =
          this.cstcsosnContribuinte.id_cst_csosn;
      }

      if (this.cstcsosnContribuinte == null) {
        this.form.id_cst_csosn_contribuinte = null;
      }

      if (this.tributacaoST != null) {
        this.form.id_tributacao_st = this.tributacaoST.id;
      }

      if (this.tributacaoST == null) {
        this.form.id_tributacao_st = null;
      }

      this.applyPerfilTributarioValues();

      const composicao = this.produtos.map((produto) => ({
        id_produto: produto.product.id,
        quantidade: this.normalizarNumeroProdutoParaEnvio(
          produto.product.quantidade
        ),
      }));
      const ids_variaveis = [];
      if (this.variacaoSelected1)
        ids_variaveis.push({
          id_variavel: this.variacaoSelected1.id_variavel,
        });
      if (this.variacaoSelected2)
        ids_variaveis.push({
          id_variavel: this.variacaoSelected2.id_variavel,
        });

      for (const key in this.form) {
        const value = this.getValorProdutoParaEnvio(key);

        // POPULATING THE PRODUTO DATA
        if (key === "data_ultima_venda" || key === "data_ultima_compra") {
          // produto.append(`${key}`, !this.form[key] ? null : this.form[key]);
        } else if (key === "imagem" && this.produtoImageWasRemoved) {
          produto.append(`${key}`, "");
        } else if (key === "unidade_medida") {
          produto.append(`${key}`, JSON.stringify(value));
        } else if (key === "restaurante_destinos") {
          produto.append(`${key}`, JSON.stringify(value));
        } else produto.append(`${key}`, value);
      }

      produto.append("remover_imagem", this.produtoImageWasRemoved ? "1" : "0");
      produto.append("ids_variaveis", JSON.stringify(ids_variaveis));
      produto.append("composicao", JSON.stringify(composicao));
      const combinacao = this.combinacao.map((item) => ({
        ...item,
        quantidade: this.normalizarNumeroProdutoParaEnvio(item.quantidade),
      }));

      produto.append("combinacao", JSON.stringify(combinacao));

      if (this.produtoSelectedPerca) {
        if (this.form.perca_percentual) {
          produto.append(
            "perca_percentual",
            this.getValorProdutoParaEnvio("perca_percentual")
          );
        }

        produto.append(
          "produto_perca",
          JSON.stringify(this.produtoSelectedPerca)
        );
      }

      if (this.isLote) {
        if (this.lotes.length) {
          const lotes = this.lotes.map((lote) => ({
            ...lote,
            quantidade: this.normalizarNumeroProdutoParaEnvio(lote.quantidade),
          }));

          produto.append(
            "baixa_automatica_lote",
            this.form.baixa_automatica_lote
          );
          produto.append("lotes", JSON.stringify(lotes));
        }
      }

      const { data } = await this.$http.post(this.url, produto);

      return data;
    },
    async onSubmit() {
      try {
        const produtoSalvo = await this.salvarProduto(
          "submit_nova_recorrencia"
        );

        if (!produtoSalvo) return;

        if (this.onboardStore.currentStep > 0) {
          this.onboardStore.currentStep = 7;
        }

        this.urlProdutoImage = null;
        this.form.imagem = null;
        this.$router.push({ name: "produtosLista" });
      } catch {
        this.removeLoadingToButton("submit_nova_recorrencia");
      }
    },
    getDescricaoProdutoDuplicado() {
      const descricao = `${this.form.descricao || ""}`.trim();

      return descricao ? `${descricao} - Cópia` : "Produto - Cópia";
    },
    async duplicarProduto() {
      try {
        const idProduto = this.produto.id || this.form.id;
        this.$bvModal.hide("modal-confirm-duplicar");
        this.addLoadingToButton("duplicar_produto");

        if (!idProduto) {
          this.$toast.error("Salve o produto antes de duplicar.");
          this.removeLoadingToButton("duplicar_produto");
          return;
        }

        const { data } = await this.$http.post("/produtos/duplicar", {
          id_produto: idProduto,
          descricao: this.getDescricaoProdutoDuplicado(),
        });

        if (!data?.id) {
          this.$toast.error(
            "Produto duplicado, mas não foi possível abrir a cópia."
          );
          this.removeLoadingToButton("duplicar_produto");
          return;
        }

        this.$toast.success("Produto duplicado com sucesso!");
        this.urlProdutoImage = null;
        this.form.imagem = null;
        this.produtoImageWasRemoved = false;
        this.$router.push({
          name: "produtosUpdate",
          params: { id_produto: data.id },
        });
      } catch {
        this.removeLoadingToButton("duplicar_produto");
      }
    },
    onSearchCFOPNfce(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOPNFCe(loading, search, this);
      }
    },
    searchCFOPNFCe: _.debounce(async (loading, search, vm) => {
      vm.cfops_nfce = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),

    onSearchCFOP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCFOP(loading, search, this);
      }
    },
    searchCFOP: _.debounce(async (loading, search, vm) => {
      vm.cfops = await vm.getCFOPByCodigo(search);
      loading(false);
    }, 350),

    onSearchCEST(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCEST(loading, search, this);
      }
    },
    searchCEST: _.debounce(async (loading, search, vm) => {
      vm.cests = await vm.getCstCest(search);
      loading(false);
    }, 350),

    onSearchNCM(search, loading) {
      if (search.length) {
        loading(true);
        this.searchNCM(loading, search, this);
      }
    },
    searchNCM: _.debounce(async (loading, search, vm) => {
      vm.ncms = await vm.getNCM(search);
      loading(false);
    }, 350),
    getNcmId(ncm) {
      if (!ncm) return null;
      return ncm.id_ncm || ncm.id || null;
    },
    getNcmCode(ncm) {
      if (!ncm) return null;
      if (typeof ncm === "string" || typeof ncm === "number") {
        return String(ncm);
      }
      return ncm.codigo || null;
    },
    getCurrentNcmId() {
      return this.getNcmId(this.ncm) || null;
    },
    hasCurrentNcmValue() {
      return !!(
        this.getCurrentNcmId() ||
        this.getNcmCode(this.ncm) ||
        this.getNcmCode(this.form.ncm)
      );
    },
    getPerfilTributarioNcm() {
      return this.perfilTributario && this.perfilTributario.ncm
        ? this.perfilTributario.ncm
        : null;
    },
    getPerfilTributarioNcmId() {
      return (
        this.getNcmId(this.getPerfilTributarioNcm()) ||
        (this.perfilTributario ? this.perfilTributario.id_ncm : null)
      );
    },
    hasPerfilTributarioNcmConflict() {
      const currentNcmId = this.getCurrentNcmId();
      const perfilNcmId = this.getPerfilTributarioNcmId();
      const currentNcmCode = this.getNcmCode(this.ncm);
      const perfilNcmCode = this.getNcmCode(this.getPerfilTributarioNcm());

      if (currentNcmId && perfilNcmId) {
        return String(currentNcmId) !== String(perfilNcmId);
      }

      if (currentNcmCode && perfilNcmCode) {
        return String(currentNcmCode) !== String(perfilNcmCode);
      }

      return !!this.hasCurrentNcmValue() && !!perfilNcmId;
    },
    getPerfilTributarioNcmTooltip() {
      const perfilNcm = this.getPerfilTributarioNcm();
      const codigo = perfilNcm
        ? perfilNcm.codigo
        : this.getPerfilTributarioNcmId();
      const descricao =
        perfilNcm && perfilNcm.descricao ? ` - ${perfilNcm.descricao}` : "";

      return `NCM do perfil tributário: ${codigo}${descricao}. Clique para aplicar.`;
    },
    getPerfilTributarioNcmLabel() {
      const perfilNcm = this.getPerfilTributarioNcm();
      const codigo = perfilNcm
        ? perfilNcm.codigo
        : this.getPerfilTributarioNcmId();

      if (!perfilNcm || !perfilNcm.descricao) return codigo;

      return `${codigo} - ${perfilNcm.descricao}`;
    },
    async loadPerfilTributarioCompleto() {
      if (!this.perfilTributario || !this.perfilTributario.id) return null;

      const { data } = await this.$http.post("/perfil-tributario/find", {
        id: this.perfilTributario.id,
      });
      const perfil = data && data.data ? data.data : data;

      if (perfil && perfil.id) {
        this.perfilTributario = {
          ...this.perfilTributario,
          ...perfil,
        };
      }

      return this.perfilTributario;
    },
    async ensurePerfilTributarioNCM() {
      const perfilNcm = this.getPerfilTributarioNcm();

      if (perfilNcm && perfilNcm.codigo) return perfilNcm;

      await this.loadPerfilTributarioCompleto();

      return this.getPerfilTributarioNcm();
    },
    shouldApplyPerfilTributarioNCM() {
      return (
        this.isPerfilTributarioValueFilled(
          "id_ncm",
          this.perfilTributario ? this.perfilTributario.id_ncm : null
        ) && !this.hasCurrentNcmValue()
      );
    },
    applyPerfilTributarioNCM() {
      const perfilNcm = this.getPerfilTributarioNcm();
      const perfilNcmId = this.getPerfilTributarioNcmId();

      if (!perfilNcmId) return;

      if (perfilNcm) {
        this.setNCM(perfilNcm);
      }

      this.form.id_ncm = perfilNcmId;
    },
    async confirmApplyPerfilTributarioNCM() {
      try {
        await this.ensurePerfilTributarioNCM();
      } catch (error) {
        this.$toast.error(
          "Não foi possível carregar o NCM do perfil tributário."
        );
        return;
      }

      if (!this.getPerfilTributarioNcmId()) {
        this.$toast.warning("O perfil tributário não possui NCM para aplicar.");
        return;
      }

      const confirmed = await this.$bvModal.msgBoxConfirm(
        `Você tem certeza que deseja alterar para o NCM ${this.getPerfilTributarioNcmLabel()}?`,
        {
          title: "Alterar NCM",
          okTitle: "Sim, aplicar",
          cancelTitle: "Cancelar",
          okVariant: "primary",
          cancelVariant: "secondary",
          centered: true,
        }
      );

      if (!confirmed) return;

      this.applyPerfilTributarioNCM();
    },

    onSearchCENQ(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCENQ(loading, search, this);
      }
    },
    searchCENQ: _.debounce(async (loading, search, vm) => {
      vm.cenqs = await vm.getCenqByCodigo(search);
      loading(false);
    }, 350),
    onSearchCSTIPI(search, loading) {
      if (search.length) {
        loading(true);
        this.searchCSTIPI(loading, search, this);
      }
    },
    searchCSTIPI: _.debounce(async (loading, search, vm) => {
      vm.cstipis = await vm.getCSTIPIByCodigo(search);
      loading(false);
    }, 350),
    onSearchANP(search, loading) {
      if (search.length) {
        loading(true);
        this.searchANP(loading, search, this);
      }
    },
    searchANP: _.debounce(async (loading, search, vm) => {
      vm.anps = await vm.getAnpByCodigo(search);
      loading(false);
    }, 350),

    onSearchFornecedor(search, loading) {
      if (search.length) {
        loading(true);
        this.searchFornecedor(loading, search, this);
      }
    },
    searchFornecedor: _.debounce(async (loading, search, vm) => {
      vm.fornecedores = await vm.getFornecedorByNome(search);
      loading(false);
    }, 350),
    onSearchGrupo(search, loading) {
      if (search.length) {
        loading(true);
        this.searchGrupo(loading, search, this);
      }
    },
    searchGrupo: _.debounce(async (loading, search, vm) => {
      vm.grupos = await vm.getGrupoByDescricao(search);
      loading(false);
    }, 350),
    isPerfilTributarioFieldLocked(field) {
      if (field === "id_ncm") return false;
      if (!this.perfilTributario || !this.perfilTributario.id) return false;

      return this.isPerfilTributarioValueFilled(
        field,
        this.perfilTributario[field]
      );
    },
    isPerfilTributarioValueFilled(field, value) {
      if (value === null || value === undefined) return false;

      const numericProfileFields = ["ipi", "pis", "cofins", "mva"];
      if (numericProfileFields.includes(field)) {
        const rawValue = String(value).trim();
        if (!rawValue) return false;

        const normalizedValue = rawValue.includes(",")
          ? rawValue.replace(/\./g, "").replace(",", ".")
          : rawValue;
        const numericValue = Number(normalizedValue);

        return Number.isFinite(numericValue)
          ? numericValue !== 0
          : rawValue !== "";
      }

      if (typeof value === "string") return value.trim() !== "";

      return true;
    },
    applyPerfilTributarioValues() {
      if (!this.perfilTributario || !this.perfilTributario.id) return;

      [
        "id_cst_csosn",
        "id_cst_csosn_contribuinte",
        "id_cfop",
        "id_cfop_nfce",
        "id_cest",
        "id_ncm",
        "id_cstipi",
        "id_cstpis",
        "id_cstcofins",
        "id_cenq",
        "id_tributacao",
        "id_tributacao_st",
        "id_fcp",
        "ipi",
        "pis",
        "cofins",
        "mva",
        "codigo_beneficio",
        "excecaoFiscal",
      ].forEach((field) => {
        if (field === "id_ncm") {
          return;
        }

        if (this.isPerfilTributarioFieldLocked(field)) {
          this.form[field] = this.perfilTributario[field];
        }
      });
    },
    setPerfilTributarioLookup(field, stateKey, relationKey, fetchList, idKey) {
      if (!this.isPerfilTributarioFieldLocked(field)) return;

      const fieldValue = this.perfilTributario[field];
      this.form[field] = fieldValue;

      if (this.perfilTributario[relationKey]) {
        this[stateKey] = this.perfilTributario[relationKey];
        return;
      }

      fetchList().then((data) => {
        const found = (data || []).find(
          (item) => String(item[idKey]) === String(fieldValue)
        );
        if (found) this[stateKey] = found;
      });
    },
    async applyPerfilTributarioNCMIfEmpty() {
      if (!this.shouldApplyPerfilTributarioNCM()) return;

      try {
        await this.ensurePerfilTributarioNCM();
      } catch (error) {
        this.$toast.error(
          "Não foi possível carregar o NCM do perfil tributário."
        );
        return;
      }

      this.applyPerfilTributarioNCM();
    },
    async setPerfilTributario(perfil) {
      this.perfilTributario = perfil;
      this.perfilTributarioSelecionado = !!(perfil && perfil.id);

      if (!this.perfilTributarioSelecionado) return;

      this.applyPerfilTributarioValues();

      this.setPerfilTributarioLookup(
        "id_cst_csosn",
        "cstcsosn",
        "cst_csosn",
        () => this.getCstCsosn(),
        "id_cst_csosn"
      );
      this.setPerfilTributarioLookup(
        "id_cst_csosn_contribuinte",
        "cstcsosnContribuinte",
        "cst_csosn_contribuinte",
        () => this.getCstCsosn(),
        "id_cst_csosn"
      );
      this.setPerfilTributarioLookup(
        "id_cfop",
        "cfop",
        "cfop",
        () => this.getCFOPByCodigo(),
        "id_cfop"
      );
      this.setPerfilTributarioLookup(
        "id_cfop_nfce",
        "cfop_nfce",
        "cfop_nfce",
        () => this.getCFOPByCodigo(),
        "id_cfop"
      );
      this.setPerfilTributarioLookup(
        "id_cest",
        "cest",
        "cest",
        () => this.getCESTByCodigo(),
        "id_cest"
      );
      await this.applyPerfilTributarioNCMIfEmpty();
      this.setPerfilTributarioLookup(
        "id_cenq",
        "cenq",
        "cenq",
        () => this.getCenqByCodigo(),
        "id_cenq"
      );
      this.setPerfilTributarioLookup(
        "id_cstipi",
        "cstipi",
        "cst_ipi",
        () => this.getCSTIPIByCodigo(),
        "id_cstipi"
      );
      this.setPerfilTributarioLookup(
        "id_cstpis",
        "cstpis",
        "cst_pis",
        () => this.getCSTPISByCodigo(),
        "id_cstpis"
      );
      this.setPerfilTributarioLookup(
        "id_cstcofins",
        "cstcofins",
        "cst_cofins",
        () => this.getCSTCofinsByCodigo(),
        "id_cstcofins"
      );
      this.setPerfilTributarioLookup(
        "id_tributacao",
        "tributacao",
        "tributacao",
        () => this.getTributacao(),
        "id"
      );
      this.setPerfilTributarioLookup(
        "id_tributacao_st",
        "tributacaoST",
        "tributacao_st",
        () => this.getTributacao(),
        "id"
      );
      this.setPerfilTributarioLookup(
        "id_fcp",
        "fcp",
        "fcp",
        () => this.getTributacao(),
        "id"
      );
    },
    onSearchPerfilTributario(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPerfilTributario(loading, search, this);
      }
    },
    searchPerfilTributario: _.debounce(async (loading, search, vm) => {
      vm.perfisTributarios = await vm.getPerfilTributarioByDescricao(search);
      loading(false);
    }, 350),
  },
};
</script>

<style>
.produto-image-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-right: 2rem;
}

.produto-image-picker-empty {
  background-color: rgba(246, 78, 96, 0.06);
  border: 1px dashed rgba(246, 78, 96, 0.45);
  color: var(--primary-color);
  font-weight: 600;
}

.produto-image-picker-empty:hover {
  background-color: color-mix(in srgb, var(--primary-color) 10%, transparent);
  border-color: color-mix(in srgb, var(--primary-color) 70%, transparent);
}

.produto-image-delete {
  color: var(--primary-color);
  font-weight: 600;
  margin-top: 0.5rem;
  padding: 0;
}

.produto-image-delete:hover {
  color: color-mix(in srgb, var(--primary-color) 80%, #000);
}

.perfil-tributario-ncm-action {
  align-items: center;
  background: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 50%;
  color: var(--primary-color);
  cursor: pointer;
  display: inline-flex;
  font-size: 10px;
  font-weight: 700;
  height: 16px;
  justify-content: center;
  line-height: 1;
  padding: 0;
  vertical-align: text-top;
  width: 16px;
}

.perfil-tributario-ncm-action:hover {
  background: var(--primary-color);
  color: #fff;
}

.vs__dropdown-toggle {
  border: 2px solid #dedede;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-radius: 6px;
  outline: none;
  height: 38px;
}
</style>
